// @ts-nocheck
/* eslint-disable */
import { useState, useEffect, useMemo, useRef } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'
import type { Nurse, Patient, Appointment, PatientDiaryEntry } from '../lib/types'
import {
  Plus, X, Check, Loader2, AlertCircle, Search,
  Calendar, Clock, MapPin, Phone, User, Users, Heart,
  ChevronLeft, ChevronRight, CheckCircle2, Circle, AlertTriangle,
  Building2, Home, Edit3, Trash2, Filter, Bell, FileText, ArrowRight,
  Crosshair, Navigation, Euro, ChevronDown, Mail, Stethoscope,
  FolderOpen, UploadCloud, Download
} from 'lucide-react'
import { sendAptosFormattedEmail } from '../lib/emailUtils'

// ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â PERCORSO TEMPLATES ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â
// Hospital meetings: date indipendenti (non legate alla timeline domiciliare)
// Domiciliari: offsetDays calcolati dal PRIMO GIORNO A DOMICILIO (dimissione)
const PERCORSO_NAIVE = {
  hospital: [
    { ordine: 0, tipo: 'training', descrizione: 'Training pompa in ospedale', luogo: 'ospedale' },
  ],
  domiciliari: [
    { ordine: 1, tipo: 'retraining', descrizione: 'Retraining paziente al rientro a domicilio (1Ãƒâ€šÃ‚Â° giorno)', luogo: 'domicilio', offsetDays: 0 },
    { ordine: 2, tipo: 'controllo', descrizione: 'Controllo PEG-J e medicazione ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Å“ Giorno 2', luogo: 'domicilio', offsetDays: 1 },
    { ordine: 3, tipo: 'controllo', descrizione: 'Controllo PEG-J e medicazione ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Å“ Giorno 3', luogo: 'domicilio', offsetDays: 2 },
    { ordine: 4, tipo: 'controllo', descrizione: 'Controllo PEG-J e medicazione ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Å“ Giorno 4', luogo: 'domicilio', offsetDays: 3 },
    { ordine: 5, tipo: 'controllo', descrizione: 'Controllo PEG-J e medicazione ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Å“ Giorno 5', luogo: 'domicilio', offsetDays: 4 },
    { ordine: 6, tipo: 'visita', descrizione: 'Visita a 17 giorni dal rientro a domicilio', luogo: 'domicilio', offsetDays: 17 },
    { ordine: 7, tipo: 'visita', descrizione: 'Visita a 30 giorni dal rientro a domicilio', luogo: 'domicilio', offsetDays: 30 },
    { ordine: 8, tipo: 'visita', descrizione: 'Visita al 2Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 60 },
    { ordine: 9, tipo: 'visita', descrizione: 'Visita al 4Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 120 },
    { ordine: 10, tipo: 'hospital_meeting', descrizione: 'Visita con neurologo al 6Ãƒâ€šÃ‚Â° mese (Accompagnato dall\'Infermiere)', luogo: 'ospedale', offsetDays: 180 },
    { ordine: 11, tipo: 'visita', descrizione: 'Visita all\'8Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 240 },
    { ordine: 12, tipo: 'visita', descrizione: 'Visita al 10Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 300 },
    { ordine: 13, tipo: 'visita', descrizione: 'Visita al 12Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 365 },
  ],
}

const PERCORSO_SWITCH = {
  hospital: [
    { ordine: 0, tipo: 'training', descrizione: 'Training pompa in ospedale', luogo: 'ospedale' },
  ],
  domiciliari: [
    { ordine: 1, tipo: 'retraining', descrizione: 'Retraining il giorno successivo alla dimissione', luogo: 'domicilio', offsetDays: 0 },
    { ordine: 2, tipo: 'visita', descrizione: 'Visita a 20 giorni dal primo training domiciliare', luogo: 'domicilio', offsetDays: 20 },
    { ordine: 3, tipo: 'visita', descrizione: 'Visita al 2Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 60 },
    { ordine: 4, tipo: 'visita', descrizione: 'Visita al 4Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 120 },
    { ordine: 5, tipo: 'hospital_meeting', descrizione: 'Visita neurologo al 6Ãƒâ€šÃ‚Â° mese (Accompagnato dall\'Infermiere)', luogo: 'ospedale', offsetDays: 180 },
    { ordine: 6, tipo: 'visita', descrizione: 'Visita all\'8Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 240 },
    { ordine: 7, tipo: 'visita', descrizione: 'Visita al 10Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 300 },
    { ordine: 8, tipo: 'visita', descrizione: 'Visita al 12Ãƒâ€šÃ‚Â° mese', luogo: 'domicilio', offsetDays: 365 },
  ],
}

const TIPO_STYLES: Record<string, { bg: string; text: string; icon: any; emoji: string }> = {
  training: { bg: 'bg-purple-50 border-purple-200', text: 'text-purple-700', icon: Building2, emoji: 'ÃƒÂ°Ã…Â¸Ã‚ÂÃ‚Â¥' },
  retraining: { bg: 'bg-blue-50 border-blue-200', text: 'text-blue-700', icon: Home, emoji: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ¢â‚¬Å¾' },
  controllo: { bg: 'bg-amber-50 border-amber-200', text: 'text-amber-700', icon: FileText, emoji: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¹' },
  visita: { bg: 'bg-emerald-50 border-emerald-200', text: 'text-emerald-700', icon: Home, emoji: 'ÃƒÂ°Ã…Â¸Ã‚ÂÃ‚Â ' },
  hospital_meeting: { bg: 'bg-rose-50 border-rose-200', text: 'text-rose-700', icon: Building2, emoji: 'ÃƒÂ°Ã…Â¸Ã‚ÂÃ‚Â¥' },
  altro: { bg: 'bg-slate-50 border-slate-200', text: 'text-slate-700', icon: Calendar, emoji: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¦' },
}

function addDays(date: string, days: number): string {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return d.toISOString().slice(0, 10)
}

function daysUntil(date: string): number {
  const now = new Date(); now.setHours(0,0,0,0)
  const target = new Date(date); target.setHours(0,0,0,0)
  return Math.round((target.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
}

export function PatientsPage() {
  const { isStaffPlus, isAdmin, isSuperAdmin, user } = useAuth()
  const [nurses, setNurses] = useState<Nurse[]>([])
  const [patients, setPatients] = useState<Patient[]>([])
  const [appointments, setAppointments] = useState<Appointment[]>([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  // Views
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null)
  const [showForm, setShowForm] = useState(false)
  const [search, setSearch] = useState('')
  const [filterNurse, setFilterNurse] = useState('')
  const [filterPercorso, setFilterPercorso] = useState('')
  const [showOnlyActive, setShowOnlyActive] = useState(true)
  const [showScadenze, setShowScadenze] = useState(false)
  const [listTab, setListTab] = useState<'pazienti' | 'accessi'>('pazienti')

  // Geo-search state
  const [geoSearching, setGeoSearching] = useState(false)
  const [geoResults, setGeoResults] = useState<{ nurse: Nurse; distanceKm: number; inRange: boolean }[]>([])
  const [geoError, setGeoError] = useState('')
  const [reassignNurseId, setReassignNurseId] = useState<string | null>(null)
  const [reassignApptIds, setReassignApptIds] = useState<Set<string>>(new Set())
  const [showClinic, setShowClinic] = useState(false)
  const [showFormClinic, setShowFormClinic] = useState(false)
  const [showRimborsi, setShowRimborsi] = useState(false)
  const [showTrash, setShowTrash] = useState(false)
  const [rimborsiApptIds, setRimborsiApptIds] = useState<Set<string>>(new Set())
  const [detailTab, setDetailTab] = useState<'anagrafica'|'clinica'|'diario'|'archivio'|'appuntamenti'|'sostituto'>('anagrafica')
  const [diary, setDiary] = useState<PatientDiaryEntry[]>([])
  const [diaryForm, setDiaryForm] = useState({ titolo: '', contenuto: '', tipo: 'nota_clinica', data: new Date().toISOString().slice(0,10) })
  const [editingDiaryId, setEditingDiaryId] = useState<string | null>(null)
  const [patientDocuments, setPatientDocuments] = useState<any[]>([])
  const [uploadingDoc, setUploadingDoc] = useState(false)

  // Ore modal state (replaces prompt())
  const [oreModal, setOreModal] = useState<{ show: boolean; appt: Appointment | null; ore: string }>({ show: false, appt: null, ore: '1' })

  // Abandonment modal state
  const [abbandonoModal, setAbbandonoModal] = useState<{ show: boolean; motivo: string; includiCompletati: boolean }>({ show: false, motivo: '', includiCompletati: false })

  // Extra access modal state
  const [showExtraAccess, setShowExtraAccess] = useState(false)
  const [extraAccessForm, setExtraAccessForm] = useState({ data: new Date().toISOString().slice(0,10), tipo: 'accessi_successivi', descrizione: '', ore: '1' })

  // Form state
  const [form, setForm] = useState<Partial<Patient> & { data_hospital?: string; data_primo_domiciliare?: string }>({
    nome: '', cognome: '', telefono: '', indirizzo: '',
    caregiver_nome: '', caregiver_cognome: '', caregiver_telefono: '',
    percorso_tipo: 'naive', data_inizio_percorso: '',
    note: '', attivo: true, nurse_id: '',
    data_hospital: '', data_primo_domiciliare: '',
  })

  useEffect(() => { fetchAll() }, [])

  async function fetchAll(showLoading = true) {
    if (showLoading) setLoading(true)
    const [nursesRes, patientsRes, appointmentsRes] = await Promise.all([
      supabase.from('nurses').select('*').order('cognome'),
      supabase.from('patients').select('*').order('cognome'),
      supabase.from('appointments').select('*').order('ordine'),
    ])
    if (nursesRes.data) setNurses(nursesRes.data)
    if (patientsRes.data) {
      setPatients(patientsRes.data)
      // Update selectedPatient reference to avoid stale data restoring on re-render
      setSelectedPatient(prev => prev ? (patientsRes.data.find(p => p.id === prev.id) || prev) : null)
    }
    if (appointmentsRes.data) setAppointments(appointmentsRes.data)
    if (showLoading) setLoading(false)
  }

  async function fetchDiary(patientId: string) {
    const { data } = await supabase.from('patient_diary').select('*').eq('patient_id', patientId).order('data', { ascending: false })
    if (data) setDiary(data)
  }

  async function handleAddDiaryEntry(patientId: string) {
    if (!diaryForm.titolo.trim()) { setError('Inserisci un titolo per la nota'); return }
    const payload: any = {
      patient_id: patientId,
      titolo: diaryForm.titolo,
      contenuto: diaryForm.contenuto,
      tipo: diaryForm.tipo,
      data: diaryForm.data
    }
    
    if (editingDiaryId) {
      const { error: err } = await supabase.from('patient_diary').update(payload).eq('id', editingDiaryId)
      if (err) { setError(err.message); return }
      setSuccess('ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â Nota modificata correttamente')
    } else {
      payload.created_by = user?.displayName || user?.email || 'Sistema'
      const { error: err } = await supabase.from('patient_diary').insert(payload)
      if (err) { setError(err.message); return }
      setSuccess('ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â Nota aggiunta al diario clinico')
    }
    
    setSuccess(editingDiaryId ? 'Nota modificata' : 'Nota aggiunta')
    setDiaryForm({ titolo: '', contenuto: '', tipo: 'nota_clinica', data: new Date().toISOString().slice(0,10) })
    setEditingDiaryId(null)
    fetchDiary(patientId)
  }

  async function fetchPatientDocuments(patientId: string) {
    const { data } = await supabase.from('documents').select('*').eq('patient_id', patientId).order('created_at', { ascending: false })
    if (data) setPatientDocuments(data)
  }

  async function handleUploadPatientDocument(file: File) {
    if (!selectedPatient) return
    setUploadingDoc(true)
    try {
      const ext = file.name.split('.').pop()
      const sanitizedName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_')
      const fileName = `${Date.now()}_${sanitizedName}`
      const filePath = `patients/${selectedPatient.id}/${fileName}`

      const { error: uploadErr } = await supabase.storage.from('documents').upload(filePath, file)
      if (uploadErr) throw uploadErr

      const { data: urlData } = supabase.storage.from('documents').getPublicUrl(filePath)
      
      const { error: dbErr } = await supabase.from('documents').insert({
        patient_id: selectedPatient.id,
        nome: file.name,
        url: urlData.publicUrl,
        categoria: ext?.toLowerCase() === 'pdf' ? 'pdf' : 'immagine',
        file_size: file.size,
        mime_type: file.type
      })
      if (dbErr) throw dbErr
      
      setSuccess('Documento caricato con successo')
      fetchPatientDocuments(selectedPatient.id)
    } catch (err: any) {
      setError(err.message || 'Errore durante il caricamento')
    } finally {
      setUploadingDoc(false)
    }
  }

  async function handleDeletePatientDocument(doc: any) {
    if (!confirm(`Vuoi davvero eliminare il file "${doc.nome}"?`)) return
    try {
      if (doc.url) {
        const pathMatch = doc.url.match(/\/documents\/(.+)$/)
        if (pathMatch) await supabase.storage.from('documents').remove([pathMatch[1]])
      }
      await supabase.from('documents').delete().eq('id', doc.id)
      setSuccess('Documento eliminato')
      if (selectedPatient) fetchPatientDocuments(selectedPatient.id)
    } catch (err: any) {
      setError(err.message || "Errore durante l'eliminazione do documento")
    }
  }

  async function handleDeleteDiaryEntry(entryId: string, patientId: string) {
    if (!confirm('Eliminare questa nota dal diario?')) return
    await supabase.from('patient_diary').delete().eq('id', entryId)
    fetchDiary(patientId)
    setSuccess('Nota eliminata')
  }

  // Filtered patients
  const filteredPatients = useMemo(() => {
    let list = patients
    if (showOnlyActive) list = list.filter(p => p.attivo)
    if (filterNurse) list = list.filter(p => p.nurse_id === filterNurse)
    if (filterPercorso) list = list.filter(p => p.percorso_tipo === filterPercorso)
    if (search) {
      const s = search.toLowerCase()
      list = list.filter(p =>
        p.nome.toLowerCase().includes(s) ||
        p.cognome.toLowerCase().includes(s) ||
        (p.telefono || '').includes(s)
      )
    }
    return list
  }, [patients, showOnlyActive, filterNurse, filterPercorso, search])

  // Scadenze: appuntamenti non completati con data_prevista <= oggi + 7 giorni
  const scadenze = useMemo(() => {
    const now = new Date(); now.setHours(0,0,0,0)
    const in7 = new Date(now); in7.setDate(in7.getDate() + 7)
    return appointments
      .filter(a => !a.completato && a.data_prevista)
      .filter(a => new Date(a.data_prevista!) <= in7)
      .sort((a, b) => new Date(a.data_prevista!).getTime() - new Date(b.data_prevista!).getTime())
  }, [appointments])

  // Patient appointments
  function getPatientAppointments(patientId: string) {
    return appointments.filter(a => a.patient_id === patientId).sort((a, b) => a.ordine - b.ordine)
  }

  function getPatientProgress(patientId: string) {
    const appts = getPatientAppointments(patientId)
    if (appts.length === 0) return 0
    return Math.round((appts.filter(a => a.completato).length / appts.length) * 100)
  }

  function getNextAppointment(patientId: string) {
    return appointments
      .filter(a => a.patient_id === patientId && !a.completato && a.data_prevista)
      .sort((a, b) => new Date(a.data_prevista!).getTime() - new Date(b.data_prevista!).getTime())[0]
  }

  // Create patient + generate appointments
  async function handleCreatePatient() {
    if (!form.nome || !form.cognome) { setError('Nome e cognome obbligatori'); return }
    if (!form.nurse_id) { setError('Seleziona un professionista'); return }
    setSaving(true); setError('')
    try {
      // Set data_inizio_percorso from the home date if provided
      const patientData = { ...form, data_inizio_percorso: form.data_primo_domiciliare || form.data_hospital || null }
      delete (patientData as any).data_hospital
      delete (patientData as any).data_primo_domiciliare

      const { data: patient, error: err } = await supabase
        .from('patients').insert(patientData).select().single()
      if (err) throw err

      const template = form.percorso_tipo === 'switch' ? PERCORSO_SWITCH : PERCORSO_NAIVE
      const appts: any[] = []

      // 1) Hospital meeting (training) ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Â data indipendente
      for (const h of template.hospital) {
        appts.push({
          patient_id: patient.id,
          nurse_id: form.nurse_id,
          tipo: h.tipo,
          descrizione: h.descrizione,
          luogo: h.luogo,
          data_prevista: form.data_hospital || null, // null se non ancora nota
          ordine: h.ordine,
          completato: false,
        })
      }

      // 2) Accessi domiciliari ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Â offset dal primo giorno a domicilio
      for (const d of template.domiciliari) {
        appts.push({
          patient_id: patient.id,
          nurse_id: form.nurse_id,
          tipo: d.tipo,
          descrizione: d.descrizione,
          luogo: d.luogo,
          data_prevista: form.data_primo_domiciliare ? addDays(form.data_primo_domiciliare, d.offsetDays) : null,
          ordine: d.ordine,
          completato: false,
        })
      }

      const { error: apptErr } = await supabase.from('appointments').insert(appts)
      if (apptErr) throw apptErr

      const msg = form.data_primo_domiciliare
        ? `Paziente creato con ${appts.length} appuntamenti programmati!`
        : `Paziente creato con ${appts.length} appuntamenti (date domiciliari da definire alla dimissione)`
      setSuccess(msg)
      setShowForm(false)
      setForm({ nome: '', cognome: '', telefono: '', indirizzo: '', caregiver_nome: '', caregiver_cognome: '', caregiver_telefono: '', percorso_tipo: 'naive', data_inizio_percorso: '', note: '', attivo: true, nurse_id: '', data_hospital: '', data_primo_domiciliare: '' })
      fetchAll()
    } catch (e: any) { setError(e.message || 'Errore nella creazione') }
    finally { setSaving(false) }
  }

  // === GEO-SEARCH: Find nearest operators from patient address ===
  function haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371
    const dLat = (lat2 - lat1) * Math.PI / 180
    const dLon = (lon2 - lon1) * Math.PI / 180
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  }

  async function geocodeAddress(address: string): Promise<{ lat: number; lon: number } | null> {
    // Try multiple address formats because Nominatim can be picky
    const variations = [
      address,
      // Remove CAP (5-digit codes) that can confuse Nominatim
      address.replace(/\b\d{5}\b/g, '').replace(/\s+/g, ' ').trim(),
      // Remove province abbreviation like 'MI', 'RM', etc at end
      address.replace(/\b[A-Z]{2}$/g, '').replace(/\s+/g, ' ').trim(),
      // Remove both CAP and province
      address.replace(/\b\d{5}\b/g, '').replace(/\b[A-Z]{2}$/g, '').replace(/\s+/g, ' ').trim(),
      // Just city name (last meaningful word)
      address.split(',').slice(-1)[0]?.trim(),
    ].filter(Boolean)

    for (const variant of variations) {
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(variant + ', Italia')}&countrycodes=it&limit=1`, {
          headers: { 'User-Agent': 'QuiCare-GestioneInfermieri/1.0' }
        })
        const data = await res.json()
        if (data.length > 0) return { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) }
      } catch {}
      await new Promise(r => setTimeout(r, 1100)) // Rate limit
    }
    return null
  }

  async function handleFindNearest() {
    if (!form.indirizzo?.trim()) { setGeoError('Inserisci prima l\'indirizzo del paziente'); return }
    setGeoSearching(true)
    setGeoError('')
    setGeoResults([])

    const target = await geocodeAddress(form.indirizzo)
    if (!target) {
      setGeoError('Indirizzo non trovato. Prova con un indirizzo piÃƒÆ’Ã‚Â¹ specifico (es: Via Roma 15, Milano).')
      setGeoSearching(false)
      return
    }

    const results: { nurse: Nurse; distanceKm: number; inRange: boolean }[] = []
    for (const nurse of nurses) {
      const nurseAddr = [nurse.indirizzo, nurse.provincia, nurse.regione].filter(Boolean).join(', ')
      if (!nurseAddr) continue
      const nurseCoord = await geocodeAddress(nurseAddr)
      if (!nurseCoord) continue
      const distanceKm = Math.round(haversineDistance(target.lat, target.lon, nurseCoord.lat, nurseCoord.lon) * 10) / 10
      const maxKm = nurse.km_spostamento ? parseFloat(nurse.km_spostamento) : 999
      results.push({ nurse, distanceKm, inRange: distanceKm <= maxKm })
      await new Promise(r => setTimeout(r, 1100)) // Rate limit Nominatim
    }

    results.sort((a, b) => a.distanceKm - b.distanceKm)
    setGeoResults(results)
    setGeoSearching(false)
    // Auto-select nearest if no nurse already selected
    if (results.length > 0 && !form.nurse_id) {
      setForm(prev => ({ ...prev, nurse_id: results[0].nurse.id }))
    }
  }

  // Same geo-search but from an existing patient's address (for substitution)
  async function handleFindNearestForPatient(address: string) {
    setGeoSearching(true)
    setGeoError('')
    setGeoResults([])

    const target = await geocodeAddress(address)
    if (!target) {
      setGeoError('Indirizzo non trovato. Verifica l\'indirizzo del paziente.')
      setGeoSearching(false)
      return
    }

    const results: { nurse: Nurse; distanceKm: number; inRange: boolean }[] = []
    for (const nurse of nurses) {
      const nurseAddr = [nurse.indirizzo, nurse.provincia, nurse.regione].filter(Boolean).join(', ')
      if (!nurseAddr) continue
      const nurseCoord = await geocodeAddress(nurseAddr)
      if (!nurseCoord) continue
      const distanceKm = Math.round(haversineDistance(target.lat, target.lon, nurseCoord.lat, nurseCoord.lon) * 10) / 10
      const maxKm = nurse.km_spostamento ? parseFloat(nurse.km_spostamento) : 999
      results.push({ nurse, distanceKm, inRange: distanceKm <= maxKm })
      await new Promise(r => setTimeout(r, 1100))
    }

    results.sort((a, b) => a.distanceKm - b.distanceKm)
    setGeoResults(results)
    setGeoSearching(false)
  }

  // Map appointment types to billing access types
  const APPT_TO_BILLING: Record<string, string> = {
    training: 'hospital_meeting',
    retraining: 'primo_accesso',
    controllo: 'accessi_successivi',
    visita: 'accessi_successivi',
    hospital_meeting: 'hospital_meeting',
  }

  // Mark appointment completed + auto-create billing access
  async function handleToggleComplete(appt: Appointment) {
    const newCompleted = !appt.completato
    const patient = patients.find(p => p.id === appt.patient_id)
    const patientName = patient ? `${patient.cognome} ${patient.nome}` : 'paziente'

    let oreImpiegate = 1
    // Confirmation dialog
    if (newCompleted) {
      // Show the React modal instead of window.prompt()
      setOreModal({ show: true, appt, ore: '1' })
      return // The actual completion will happen in handleConfirmOreModal
    } else {
      if (!confirm(`ÃƒÂ¢Ã…Â¡Ã‚Â ÃƒÂ¯Ã‚Â¸Ã‚Â Riaprire l'appuntamento "${appt.descrizione}" per ${patientName}?\n\nL'accesso in fatturazione collegato verrÃƒÆ’Ã‚Â  eliminato automaticamente.`)) return
    }

    const today = new Date().toISOString().slice(0, 10)

    // Update appointment
    const { error: err } = await supabase.from('appointments').update({
      completato: newCompleted,
      data_effettiva: newCompleted ? today : null,
    }).eq('id', appt.id)
    if (err) { setError(err.message); return }

    // Auto-create billing access if completing
    if (newCompleted && appt.nurse_id) {
      const billingTipo = APPT_TO_BILLING[appt.tipo] || 'accessi_successivi'
      const savedRates = localStorage.getItem('quicare_billing_rates_v2')
      const rates = savedRates ? JSON.parse(savedRates) : { hospital_meeting: 50, primo_accesso: 50, accessi_successivi: 40, training_farmaceutica: 50 }
      const rate = rates[billingTipo] || 50

      const { data: access, error: accErr } = await supabase.from('accesses').insert({
        nurse_id: appt.nurse_id,
        data: today,
        tipo: billingTipo,
        ore: oreImpiegate,
        costo_orario: rate,
        descrizione: appt.descrizione,
        note: `Auto: ${patientName}`,
      }).select().single()

      if (!accErr && access) {
        await supabase.from('appointments').update({ access_id: access.id }).eq('id', appt.id)
      }
    }

    // If uncompleting, remove linked access
    if (!newCompleted && appt.access_id) {
      await supabase.from('accesses').delete().eq('id', appt.access_id)
      await supabase.from('appointments').update({ access_id: null }).eq('id', appt.id)
    }

    // Refresh all data to stay in sync
    await fetchAll()
    setSuccess(newCompleted ? `ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Appuntamento completato + accesso registrato per ${patientName}` : `ÃƒÂ¢Ã¢â‚¬Â Ã‚Â©ÃƒÂ¯Ã‚Â¸Ã‚Â Appuntamento riaperto e accesso rimosso per ${patientName}`)
  }

  // Handle the ore modal confirmation
  async function handleConfirmOreModal() {
    const appt = oreModal.appt
    if (!appt) return
    // Read directly from DOM to avoid any React stale closure issues
    const inputEl = document.getElementById('ore-modal-input') as HTMLInputElement | null
    const oreValue = inputEl ? inputEl.value : '1'
    const oreImpiegate = parseFloat(oreValue.replace(',', '.')) || 1
    setOreModal({ show: false, appt: null, ore: '1' })

    const patient = patients.find(p => p.id === appt.patient_id)
    const patientName = patient ? `${patient.cognome} ${patient.nome}` : 'paziente'
    const today = new Date().toISOString().slice(0, 10)
    // Per la fatturazione usa la data prevista dell'appuntamento, non la data di inserimento
    const billingDate = appt.data_prevista || today

    const { error: err } = await supabase.from('appointments').update({
      completato: true,
      data_effettiva: today,
    }).eq('id', appt.id)
    if (err) { setError(err.message); return }

    if (appt.nurse_id) {
      const billingTipo = APPT_TO_BILLING[appt.tipo] || 'accessi_successivi'
      const savedRates = localStorage.getItem('quicare_billing_rates_v2')
      const rates = savedRates ? JSON.parse(savedRates) : { hospital_meeting: 50, primo_accesso: 50, accessi_successivi: 40, training_farmaceutica: 50 }
      const rate = rates[billingTipo] || 50

      const { data: access, error: accErr } = await supabase.from('accesses').insert({
        nurse_id: appt.nurse_id,
        data: billingDate,
        tipo: billingTipo,
        ore: oreImpiegate,
        costo_orario: rate,
        descrizione: appt.descrizione,
        note: `Auto: ${patientName}`,
      }).select().single()

      if (!accErr && access) {
        await supabase.from('appointments').update({ access_id: access.id }).eq('id', appt.id)
      }
    }

    await fetchAll()
    setSuccess(`ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Appuntamento completato (${oreImpiegate}h) + accesso registrato per ${patientName}`)
  }


  // Create extra access (both appointment + billing access)
  async function handleExtraAccess() {
    if (!selectedPatient) return
    const ore = parseFloat(extraAccessForm.ore.replace(',', '.')) || 1
    const nurseId = selectedPatient.nurse_id
    const APPT_TIPO_MAP: Record<string, string> = { hospital_meeting: 'hospital_meeting', primo_accesso: 'primo_accesso', accessi_successivi: 'accesso_domiciliare', training_farmaceutica: 'training' }
    const apptTipo = APPT_TIPO_MAP[extraAccessForm.tipo] || 'accesso_domiciliare'
    const { data: appt, error: err1 } = await supabase.from('appointments').insert({
      patient_id: selectedPatient.id, nurse_id: nurseId, tipo: apptTipo,
      descrizione: extraAccessForm.descrizione || 'Accesso Extra',
      luogo: extraAccessForm.tipo === 'hospital_meeting' ? 'ospedale' : 'domicilio',
      data_prevista: extraAccessForm.data, data_effettiva: new Date().toISOString().slice(0, 10),
      completato: true, ordine: 999,
    }).select().single()
    if (err1) { setError(err1.message); return }
    if (nurseId && appt) {
      const savedRates = localStorage.getItem('quicare_billing_rates_v2')
      const rates = savedRates ? JSON.parse(savedRates) : { hospital_meeting: 50, primo_accesso: 50, accessi_successivi: 40, training_farmaceutica: 50 }
      const rate = rates[extraAccessForm.tipo] || 50
      const { data: access } = await supabase.from('accesses').insert({
        nurse_id: nurseId, data: extraAccessForm.data, tipo: extraAccessForm.tipo,
        ore, costo_orario: rate, descrizione: extraAccessForm.descrizione || 'Accesso Extra',
        note: `Extra: ${selectedPatient.cognome} ${selectedPatient.nome}`,
      }).select().single()
      if (access) await supabase.from('appointments').update({ access_id: access.id }).eq('id', appt.id)
    }
    setShowExtraAccess(false)
    setExtraAccessForm({ data: new Date().toISOString().slice(0,10), tipo: 'accessi_successivi', descrizione: '', ore: '1' })
    await fetchAll()
    setSuccess('Accesso extra registrato!')
  }

  // Update ore on a linked access
  async function handleUpdateAccessOre(accessId: string, newOre: number) {
    await supabase.from('accesses').update({ ore: newOre }).eq('id', accessId)
    setSuccess(`Ore aggiornate a ${newOre}h`)
  }

  // Bulk update rimborsi km/extra on selected accesses
  async function handleBulkRimborsi(apptIds: Set<string>, km: number, rimborsoKm: number, extra: number) {
    let count = 0
    for (const apptId of apptIds) {
      const appt = appointments.find(a => a.id === apptId)
      if (appt?.access_id) {
        await supabase.from('accesses').update({
          km_percorsi: km, rimborso_km: rimborsoKm, rimborso_extra: extra
        }).eq('id', appt.access_id)
        count++
      }
    }
    setRimborsiApptIds(new Set())
    setShowRimborsi(false)
    setSuccess(`ÃƒÂ°Ã…Â¸Ã¢â‚¬â„¢Ã‚Â° Rimborsi aggiornati su ${count} access${count === 1 ? 'o' : 'i'}`)
  }

  // Reassign nurse for single appointment
  async function handleReassignApptNurse(apptId: string, newNurseId: string) {
    const { error: err } = await supabase.from('appointments').update({ nurse_id: newNurseId }).eq('id', apptId)
    if (err) { setError(err.message); return }
    setAppointments(prev => prev.map(a => a.id === apptId ? { ...a, nurse_id: newNurseId } : a))
    const nurseName = getNurseName(newNurseId)
    setSuccess(`Appuntamento riassegnato a ${nurseName}`)
  }

  // Batch-reassign multiple appointments to a nurse
  async function handleBatchReassign(nurseId: string, apptIds: Set<string>) {
    if (apptIds.size === 0) return
    let count = 0
    for (const apptId of apptIds) {
      const { error } = await supabase.from('appointments').update({ nurse_id: nurseId }).eq('id', apptId)
      if (!error) count++
    }
    setAppointments(prev => prev.map(a => apptIds.has(a.id) ? { ...a, nurse_id: nurseId } : a))
    setReassignNurseId(null)
    setReassignApptIds(new Set())
    setSuccess(`${count} appuntament${count === 1 ? 'o riassegnato' : 'i riassegnati'} a ${getNurseName(nurseId)}`)
  }

  // Reassign nurse permanently for patient + all future appointments
  async function handleReassignPatientNurse(patient: Patient, newNurseId: string) {
    const { error: err1 } = await supabase.from('patients').update({ nurse_id: newNurseId }).eq('id', patient.id)
    if (err1) { setError(err1.message); return }
    // Update all non-completed appointments
    const { error: err2 } = await supabase.from('appointments').update({ nurse_id: newNurseId })
      .eq('patient_id', patient.id).eq('completato', false)
    if (err2) { setError(err2.message); return }
    setSelectedPatient({ ...patient, nurse_id: newNurseId })
    setAppointments(prev => prev.map(a => a.patient_id === patient.id && !a.completato ? { ...a, nurse_id: newNurseId } : a))
    setPatients(prev => prev.map(p => p.id === patient.id ? { ...p, nurse_id: newNurseId } : p))
    setSuccess(`Professionista riassegnato permanentemente a ${getNurseName(newNurseId)}`)
  }

  // Update appointment date
  async function handleUpdateDate(apptId: string, newDate: string) {
    if (!newDate) return
    const { error: err } = await supabase.from('appointments').update({ data_prevista: newDate }).eq('id', apptId)
    if (err) { setError(err.message); return }
    setAppointments(prev => prev.map(a => a.id === apptId ? { ...a, data_prevista: newDate } : a))
  }

  // Update appointment time (optional memo)
  async function handleUpdateTime(apptId: string, newTime: string) {
    const { error: err } = await supabase.from('appointments').update({ ora_prevista: newTime || null }).eq('id', apptId)
    if (err) { setError(err.message); return }
    setAppointments(prev => prev.map(a => a.id === apptId ? { ...a, ora_prevista: newTime || undefined } : a))
  }

  // Delete patient
  async function handleDeletePatient(patient: Patient) {
    if (!confirm(`Eliminare ${patient.cognome} ${patient.nome} e tutti i suoi appuntamenti?`)) return
    const { error: err } = await supabase.from('patients').delete().eq('id', patient.id)
    if (err) { setError(err.message); return }
    setSelectedPatient(null)
    setSuccess('Paziente eliminato')
    fetchAll()
  }

  // Abandon program
  async function handleAbbandonoProgramma(patient: Patient) {
    const motivo = abbandonoModal.motivo.trim()
    if (!motivo) { setError('Inserisci la motivazione dell\'abbandono'); return }

    const today = new Date().toISOString().slice(0, 10)

    // 1. Mark patient as inactive with abandonment info
    const { error: err1 } = await supabase.from('patients').update({
      attivo: false,
      motivo_abbandono: motivo,
      data_abbandono: today,
    }).eq('id', patient.id)
    if (err1) { setError(err1.message); return }

    // 2. Delete appointments based on user choice
    const patientAppts = appointments.filter(a => a.patient_id === patient.id)
    const toDelete = abbandonoModal.includiCompletati
      ? patientAppts
      : patientAppts.filter(a => !a.completato)

    let deletedCount = 0
    for (const appt of toDelete) {
      // Also remove linked billing access if exists
      if (appt.access_id) {
        await supabase.from('accesses').delete().eq('id', appt.access_id)
      }
      const { error: delErr } = await supabase.from('appointments').delete().eq('id', appt.id)
      if (!delErr) deletedCount++
    }

    // 3. Auto-add diary entry for traceability
    await supabase.from('patient_diary').insert({
      patient_id: patient.id,
      titolo: 'ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â« Programma abbandonato',
      contenuto: `Motivazione: ${motivo}\n\nAppuntamenti eliminati: ${deletedCount}${abbandonoModal.includiCompletati ? ' (inclusi completati)' : ' (solo non completati)'}`,
      tipo: 'evento',
      data: today,
      created_by: user?.displayName || user?.email || 'Sistema',
    })

    setAbbandonoModal({ show: false, motivo: '', includiCompletati: false })
    setSelectedPatient({ ...patient, attivo: false, motivo_abbandono: motivo, data_abbandono: today })
    setSuccess(`ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â« Programma di ${patient.cognome} ${patient.nome} segnato come abbandonato. ${deletedCount} appuntament${deletedCount === 1 ? 'o eliminato' : 'i eliminati'}.`)
    await fetchAll()
  }

  // Generate next 6 months of appointments (after 12 months)
  async function handleGenerateExtension(patient: Patient) {
    const appts = getPatientAppointments(patient.id)
    const lastOrdine = Math.max(...appts.map(a => a.ordine), 0)
    const lastDate = appts.length > 0 ? appts.reduce((max, a) => a.data_prevista && a.data_prevista > max ? a.data_prevista : max, '2000-01-01') : patient.data_inizio_percorso || new Date().toISOString().slice(0, 10)

    const newAppts = []
    for (let i = 1; i <= 3; i++) {
      newAppts.push({
        patient_id: patient.id,
        nurse_id: patient.nurse_id,
        tipo: 'visita',
        descrizione: `Visita bimestrale #${lastOrdine + i}`,
        luogo: 'domicilio',
        data_prevista: addDays(lastDate, i * 60),
        ordine: lastOrdine + i,
        completato: false,
      })
    }

    const { error: err } = await supabase.from('appointments').insert(newAppts)
    if (err) { setError(err.message); return }
    setSuccess(`Generati ${newAppts.length} appuntamenti per i prossimi 6 mesi`)
    fetchAll()
  }

  // Nurse lookup
  function getNurseName(nurseId?: string) {
    if (!nurseId) return 'Non assegnato'
    const n = nurses.find(n => n.id === nurseId)
    return n ? `${n.cognome} ${n.nome}` : 'Sconosciuto'
  }

  // Clear messages
  useEffect(() => {
    if (success || error) {
      const t = setTimeout(() => { setSuccess(''); setError('') }, 4000)
      return () => clearTimeout(t)
    }
  }, [success, error])

  if (loading) return <div className="flex items-center justify-center py-16 text-slate-400"><Loader2 className="w-6 h-6 animate-spin mr-2" /> Caricamento pazienti...</div>

  // Computed values for detail view
  const appts = selectedPatient ? getPatientAppointments(selectedPatient.id) : []
  const progress = selectedPatient ? getPatientProgress(selectedPatient.id) : 0
  const nurse = selectedPatient ? nurses.find(n => n.id === selectedPatient.nurse_id) : null

  return (
    <>
    {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â DETTAGLIO PAZIENTE ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
    {selectedPatient ? (
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-4">
            <button onClick={() => setSelectedPatient(null)} className="p-2 hover:bg-slate-100 rounded-xl transition-colors">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <div className="flex-1 min-w-0">
              <h2 className="text-2xl font-black text-slate-800 truncate">{selectedPatient.cognome} {selectedPatient.nome}</h2>
              <div className="flex items-center gap-3 mt-1 flex-wrap">
                <span className={`text-xs font-bold px-2.5 py-0.5 rounded-lg ${selectedPatient.percorso_tipo === 'naive' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                  Percorso {selectedPatient.percorso_tipo === 'naive' ? 'NAÃƒÆ’Ã‚ÂVE' : 'SWITCH'}
                </span>
                {nurse && <span className="text-xs text-slate-500">ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ‚Â¤ {nurse.cognome} {nurse.nome}</span>}
                {selectedPatient.motivo_abbandono ? (
                  <span className="text-xs font-bold px-2 py-0.5 rounded-lg bg-red-100 text-red-700">ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â« Abbandonato</span>
                ) : (
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-lg ${selectedPatient.attivo ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'}`}>
                    {selectedPatient.attivo ? 'ÃƒÂ¢Ã¢â‚¬â€Ã‚Â Attivo' : 'ÃƒÂ¢Ã¢â‚¬â€Ã¢â‚¬Â¹ Concluso'}
                  </span>
                )}
              </div>
            </div>
          </div>
          {isStaffPlus && (
            <div className="flex items-center gap-2 flex-wrap">
              <select
                value={selectedPatient.nurse_id || ''}
                onChange={e => handleReassignPatientNurse(selectedPatient, e.target.value)}
                className="px-2 py-1 text-xs border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500">
                {nurses.map(n => <option key={n.id} value={n.id}>{n.cognome} {n.nome}</option>)}
              </select>
              {selectedPatient.attivo && !selectedPatient.motivo_abbandono && (
                <button onClick={() => setAbbandonoModal({ show: true, motivo: '', includiCompletati: false })} className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-600 rounded-xl text-xs font-bold transition-all border border-red-200" title="Segna programma come abbandonato">
                  <X className="w-4 h-4" /> Programma Abbandonato
                </button>
              )}
              <button onClick={() => { setForm(selectedPatient); setShowForm(true); }} className="p-2 hover:bg-slate-100 rounded-xl text-slate-500 transition-colors" title="Modifica dati anagrafici">
                <Edit3 className="w-5 h-5" />
              </button>
              <button onClick={() => handleDeletePatient(selectedPatient)} className="p-2 hover:bg-red-50 rounded-xl text-red-400 transition-colors" title="Elimina paziente">
                <Trash2 className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>

        {/* Messages */}
        {error && <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700"><AlertCircle className="w-4 h-4" />{error}</div>}
        {success && <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-xl text-sm text-green-700"><Check className="w-4 h-4" />{success}</div>}

        {/* Progress Bar */}
        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl p-4 flex items-center gap-4 text-white">
          <div className="flex-1">
            <div className="h-2 bg-white/20 rounded-full overflow-hidden">
              <div className="h-full bg-white/80 rounded-full transition-all duration-700" style={{ width: `${progress}%` }} />
            </div>
          </div>
          <div className="text-sm font-black">{progress}%</div>
          <div className="text-xs text-indigo-200">{appts.filter(a => a.completato).length}/{appts.length}</div>
        </div>

        {/* Tab Navigation */}
        <div className="flex gap-1 bg-slate-100 rounded-xl p-1 overflow-x-auto">
          {([
            { key: 'anagrafica', label: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¹ Anagrafica', icon: User },
            { key: 'clinica', label: 'ÃƒÂ°Ã…Â¸Ã‚ÂÃ‚Â¥ Clinica', icon: Stethoscope },
            { key: 'diario', label: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â Diario', icon: FileText },
            { key: 'archivio', label: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â Archivio', icon: FolderOpen },
            { key: 'appuntamenti', label: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¦ Agenda', icon: Calendar },
            { key: 'sostituto', label: 'ÃƒÂ°Ã…Â¸Ã…Â½Ã‚Â¯ Sostituto', icon: Crosshair },
          ] as const).map(tab => (
            <button key={tab.key} onClick={() => { 
                setDetailTab(tab.key as any); 
                if (tab.key === 'diario') fetchDiary(selectedPatient.id);
                if (tab.key === 'archivio') fetchPatientDocuments(selectedPatient.id);
              }}
              className={`flex-1 min-w-[120px] flex items-center justify-center gap-1.5 py-2.5 rounded-lg text-xs font-bold transition-all ${
                detailTab === tab.key ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-400 hover:text-slate-600'}`}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: ANAGRAFICA ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
        {detailTab === 'anagrafica' && (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Paziente */}
              <div className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
                <div className="text-xs font-bold text-slate-400 uppercase flex items-center gap-1"><User className="w-3.5 h-3.5" /> Paziente</div>
                {selectedPatient.telefono && <div className="flex items-center gap-2 text-sm"><Phone className="w-4 h-4 text-blue-500" /> <a href={`tel:${selectedPatient.telefono}`} className="text-blue-600 hover:underline">{selectedPatient.telefono}</a></div>}
                {selectedPatient.email && <div className="flex items-center gap-2 text-sm"><Mail className="w-4 h-4 text-indigo-500" /> <button onClick={(e) => { e.preventDefault(); sendAptosFormattedEmail(selectedPatient.email || '', '', ''); }} className="text-indigo-600 hover:underline">{selectedPatient.email}</button></div>}
                {selectedPatient.indirizzo && <div className="flex items-center gap-2 text-sm"><MapPin className="w-4 h-4 text-emerald-500" /> {selectedPatient.indirizzo}</div>}
                {/* Editable Centro Ospedaliero */}
                {isStaffPlus ? (
                  <div className="flex items-center gap-2 text-sm group mt-2 pt-2 border-t border-slate-100">
                    <Building2 className="w-4 h-4 text-purple-500 flex-shrink-0" />
                    <input type="text" defaultValue={selectedPatient.centro_ospedaliero || ''} 
                      placeholder="Inserisci centro clinico di riferimento..."
                      onBlur={e => supabase.from('patients').update({ centro_ospedaliero: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                      className="bg-transparent border-b border-transparent hover:border-dashed hover:border-slate-300 focus:border-solid focus:border-purple-500 focus:outline-none w-full text-slate-700 placeholder:text-slate-300 transition-colors"
                      title="Centro clinico di riferimento"
                    />
                  </div>
                ) : selectedPatient.centro_ospedaliero && (
                  <div className="flex items-center gap-2 text-sm text-slate-700 mt-2 pt-2 border-t border-slate-100">
                    <Building2 className="w-4 h-4 text-purple-500" /> {selectedPatient.centro_ospedaliero}
                  </div>
                )}
                {selectedPatient.data_inizio_percorso && <div className="flex items-center gap-2 text-sm"><Calendar className="w-4 h-4 text-amber-500" /> Inizio: {new Date(selectedPatient.data_inizio_percorso).toLocaleDateString('it-IT')}</div>}
              </div>

              {/* Caregiver */}
              <div className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
                <div className="text-xs font-bold text-slate-400 uppercase flex items-center gap-1"><Heart className="w-3.5 h-3.5" /> Caregiver</div>
                {(selectedPatient.caregiver_nome || selectedPatient.caregiver_cognome) ? (
                  <>
                    <div className="text-sm font-bold text-slate-700">{selectedPatient.caregiver_nome} {selectedPatient.caregiver_cognome}</div>
                    {selectedPatient.caregiver_telefono && <div className="flex items-center gap-2 text-sm"><Phone className="w-4 h-4 text-blue-500" /> <a href={`tel:${selectedPatient.caregiver_telefono}`} className="text-blue-600 hover:underline">{selectedPatient.caregiver_telefono}</a></div>}
                  </>
                ) : <div className="text-sm text-slate-300 italic">Non registrato</div>}
              </div>

              {/* Case Manager */}
              <div className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
                <div className="text-xs font-bold text-slate-400 uppercase flex items-center gap-1"><Building2 className="w-3.5 h-3.5" /> Case Manager</div>
                {isStaffPlus ? (
                  <div className="space-y-2">
                    <div className="grid grid-cols-2 gap-2">
                      <input type="text" defaultValue={selectedPatient.case_manager_nome || ''} placeholder="Nome"
                        onBlur={e => supabase.from('patients').update({ case_manager_nome: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                        className="px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                      <input type="text" defaultValue={selectedPatient.case_manager_cognome || ''} placeholder="Cognome"
                        onBlur={e => supabase.from('patients').update({ case_manager_cognome: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                        className="px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                    </div>
                    <input type="tel" defaultValue={selectedPatient.case_manager_telefono || ''} placeholder="Telefono"
                      onBlur={e => supabase.from('patients').update({ case_manager_telefono: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                      className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                    <input type="email" defaultValue={selectedPatient.case_manager_email || ''} placeholder="Email"
                      onBlur={e => supabase.from('patients').update({ case_manager_email: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                      className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                  </div>
                ) : (selectedPatient.case_manager_nome || selectedPatient.case_manager_cognome) ? (
                  <>
                    <div className="text-sm font-bold text-slate-700">{selectedPatient.case_manager_nome} {selectedPatient.case_manager_cognome}</div>
                    {selectedPatient.case_manager_telefono && <div className="flex items-center gap-2 text-sm"><Phone className="w-4 h-4 text-blue-500" /> {selectedPatient.case_manager_telefono}</div>}
                    {selectedPatient.case_manager_email && <div className="flex items-center gap-2 text-sm"><Mail className="w-4 h-4 text-indigo-500" /> {selectedPatient.case_manager_email}</div>}
                  </>
                ) : <div className="text-sm text-slate-300 italic">Non registrato</div>}
              </div>

              {/* Specialista */}
              <div className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
                <div className="text-xs font-bold text-slate-400 uppercase flex items-center gap-1"><Stethoscope className="w-3.5 h-3.5" /> Specialista</div>
                {isStaffPlus ? (
                  <div className="space-y-2">
                    <input type="text" defaultValue={selectedPatient.specialista_nome || ''} placeholder="Nome specialista"
                      onBlur={e => supabase.from('patients').update({ specialista_nome: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                      className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                    <input type="tel" defaultValue={selectedPatient.specialista_telefono || ''} placeholder="Telefono"
                      onBlur={e => supabase.from('patients').update({ specialista_telefono: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                      className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                    <input type="email" defaultValue={selectedPatient.specialista_email || ''} placeholder="Email"
                      onBlur={e => supabase.from('patients').update({ specialista_email: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                      className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500" />
                  </div>
                ) : selectedPatient.specialista_nome ? (
                  <>
                    <div className="text-sm font-bold text-slate-700">{selectedPatient.specialista_nome}</div>
                    {selectedPatient.specialista_telefono && <div className="flex items-center gap-2 text-sm"><Phone className="w-4 h-4 text-blue-500" /> {selectedPatient.specialista_telefono}</div>}
                    {selectedPatient.specialista_email && <div className="flex items-center gap-2 text-sm"><Mail className="w-4 h-4 text-indigo-500" /> {selectedPatient.specialista_email}</div>}
                  </>
                ) : <div className="text-sm text-slate-300 italic">Non registrato</div>}
              </div>
            </div>

            {/* Note */}
            {selectedPatient.note && (
              <div className="bg-amber-50 rounded-xl border border-amber-200 p-4 text-sm text-amber-800">
                <span className="font-bold">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â Note:</span> {selectedPatient.note}
              </div>
            )}

            {/* Abandonment banner */}
            {selectedPatient.motivo_abbandono && (
              <div className="bg-red-50 rounded-2xl border-2 border-red-200 p-5">
                <div className="flex items-center gap-3">
                  <div className="p-2.5 bg-red-100 rounded-xl"><AlertTriangle className="w-5 h-5 text-red-600" /></div>
                  <div className="flex-1">
                    <div className="text-sm font-black text-red-800">ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â« Programma Abbandonato</div>
                    <div className="text-xs text-red-600 mt-0.5">
                      {selectedPatient.data_abbandono && `Data: ${new Date(selectedPatient.data_abbandono).toLocaleDateString('it-IT')} Ãƒâ€šÃ‚Â· `}
                      Motivazione:
                    </div>
                    <div className="text-sm text-red-700 mt-2 bg-white/60 rounded-lg p-3 border border-red-100 whitespace-pre-wrap">{selectedPatient.motivo_abbandono}</div>
                  </div>
                </div>
              </div>
            )}

            {/* Attiva percorso domiciliare */}
            {isStaffPlus && appts.some(a => !a.completato && !a.data_prevista) && (() => {
              const noDateCount = appts.filter(a => !a.completato && !a.data_prevista).length
              return (
                <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl border-2 border-dashed border-amber-300 p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 bg-amber-100 rounded-xl"><Calendar className="w-5 h-5 text-amber-600" /></div>
                    <div>
                      <div className="text-sm font-black text-amber-800">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¦ Attiva Percorso Domiciliare</div>
                      <div className="text-xs text-amber-600">{noDateCount} appuntament{noDateCount > 1 ? 'i' : 'o'} in attesa di data dimissione</div>
                    </div>
                  </div>
                  <div className="flex items-end gap-3">
                    <div className="flex-1">
                      <label className="block text-[10px] font-bold text-amber-700 mb-1 uppercase">Data Dimissione / Primo Domiciliare</label>
                      <input type="date" id="activateDate" className="w-full px-3 py-2.5 border border-amber-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white" />
                    </div>
                    <button onClick={async () => {
                        const dateInput = document.getElementById('activateDate') as HTMLInputElement
                        if (!dateInput?.value) { setError('Seleziona la data di dimissione'); return }
                        const startDate = dateInput.value
                        const template = selectedPatient.percorso_tipo === 'switch' ? PERCORSO_SWITCH : PERCORSO_NAIVE
                        const noDateAppts = appts.filter(a => !a.completato && !a.data_prevista)
                        let count = 0
                        for (const appt of noDateAppts) {
                          const tmpl = template.domiciliari.find(d => d.ordine === appt.ordine)
                          if (tmpl) {
                            await supabase.from('appointments').update({ data_prevista: addDays(startDate, tmpl.offsetDays) }).eq('id', appt.id)
                            count++
                          }
                        }
                        await supabase.from('patients').update({ data_inizio_percorso: startDate }).eq('id', selectedPatient.id)
                        setSelectedPatient({ ...selectedPatient, data_inizio_percorso: startDate })
                        await fetchAll()
                        setSuccess(`ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Percorso attivato! ${count} date calcolate dal ${new Date(startDate).toLocaleDateString('it-IT')}`)
                      }}
                      className="flex items-center gap-1.5 px-5 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl shadow-md hover:shadow-lg transition-all">
                      <Check className="w-4 h-4" /> Attiva Percorso
                    </button>
                  </div>
                </div>
              )
            })()}
          </div>
        )}

        {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: CLINICA ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
        {detailTab === 'clinica' && (
          <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-5">
            {/* Patologia + Neurologo */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Patologia</label>
                <input type="text" defaultValue={selectedPatient.patologia || ''} onBlur={e => supabase.from('patients').update({ patologia: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Neurologo Prescrittore</label>
                <input type="text" defaultValue={selectedPatient.neurologo_prescrittore || ''} onBlur={e => supabase.from('patients').update({ neurologo_prescrittore: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
            </div>
            {/* Pompa + Tubo */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Seriale Pompa</label>
                <input type="text" defaultValue={selectedPatient.seriale_pompa || ''} onBlur={e => supabase.from('patients').update({ seriale_pompa: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Dimensioni Tubo</label>
                <input type="text" defaultValue={selectedPatient.dimensioni_tubo || ''} onBlur={e => supabase.from('patients').update({ dimensioni_tubo: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
            </div>
            {/* Date */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Data Impianto PEG-J</label>
                <input type="date" defaultValue={selectedPatient.data_impianto_pegj || ''} onBlur={e => supabase.from('patients').update({ data_impianto_pegj: e.target.value || null }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Sostituzione PEG</label>
                <input type="date" defaultValue={selectedPatient.data_sostituzione_peg || ''} onBlur={e => supabase.from('patients').update({ data_sostituzione_peg: e.target.value || null }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Dimissione Prevista</label>
                <input type="date" defaultValue={selectedPatient.data_dimissione_prevista || ''} onBlur={e => supabase.from('patients').update({ data_dimissione_prevista: e.target.value || null }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Inizio Terapia</label>
                <input type="date" defaultValue={selectedPatient.data_inizio_terapia || ''} onBlur={e => supabase.from('patients').update({ data_inizio_terapia: e.target.value || null }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
              </div>
            </div>
            {/* Dosaggi */}
            <div className="grid grid-cols-5 gap-4">
              {(['dosaggio_f1','dosaggio_f2','dosaggio_f3','dose_mattutina','dose_extra'] as const).map(f => (
                <div key={f}>
                  <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">
                    {f === 'dosaggio_f1' ? 'Dosaggio F1' : f === 'dosaggio_f2' ? 'Dosaggio F2' : f === 'dosaggio_f3' ? 'Dosaggio F3' : f === 'dose_mattutina' ? 'Dose Matt.' : 'Dose Extra'}
                  </label>
                  <input type="text" defaultValue={(selectedPatient as any)[f] || ''} onBlur={e => supabase.from('patients').update({ [f]: e.target.value }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                    className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-teal-500" />
                </div>
              ))}
            </div>
            {/* Flags */}
            <div className="flex items-center gap-8 pt-2 border-t border-slate-100">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" defaultChecked={selectedPatient.nutrizione_parenterale || false}
                  onChange={e => supabase.from('patients').update({ nutrizione_parenterale: e.target.checked }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="rounded border-slate-300 text-teal-600 focus:ring-teal-500" />
                <span className="text-sm text-slate-700">Nutrizione Parenterale</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" defaultChecked={selectedPatient.discinetico || false}
                  onChange={e => supabase.from('patients').update({ discinetico: e.target.checked }).eq('id', selectedPatient.id).then(() => fetchAll(false))}
                  className="rounded border-slate-300 text-teal-600 focus:ring-teal-500" />
                <span className="text-sm text-slate-700">Discinetico</span>
              </label>
            </div>
          </div>
        )}

        {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: DIARIO ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
        {detailTab === 'diario' && (
          <div className="space-y-4">
            {/* Add entry form */}
            {isStaffPlus && (
              <div className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
                <div className="text-xs font-bold text-slate-400 uppercase">{editingDiaryId ? 'ÃƒÂ¢Ã…â€œÃ‚ÂÃƒÂ¯Ã‚Â¸Ã‚Â Modifica Nota' : 'Nuova Nota'}</div>
                <div className="grid grid-cols-3 gap-3">
                  <input type="text" value={diaryForm.titolo} onChange={e => setDiaryForm({ ...diaryForm, titolo: e.target.value })}
                    placeholder="Titolo nota..." className="col-span-2 px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                  <div className="flex gap-2">
                    <select value={diaryForm.tipo} onChange={e => setDiaryForm({ ...diaryForm, tipo: e.target.value })}
                      className="flex-1 px-2 py-2 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-500">
                      <option value="nota_clinica">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¹ Nota Clinica</option>
                      <option value="cambio_peg">ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â§ Cambio PEG</option>
                      <option value="evento">ÃƒÂ¢Ã…Â¡Ã‚Â¡ Evento</option>
                      <option value="altro">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã…â€™ Altro</option>
                    </select>
                    <input type="date" value={diaryForm.data} onChange={e => setDiaryForm({ ...diaryForm, data: e.target.value })}
                      className="px-2 py-2 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                  </div>
                </div>
                <textarea value={diaryForm.contenuto} onChange={e => setDiaryForm({ ...diaryForm, contenuto: e.target.value })}
                  rows={3} placeholder="Descrizione dettagliata..."
                  className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none" />
                <div className="flex items-center gap-2">
                  <button onClick={() => handleAddDiaryEntry(selectedPatient.id)}
                    className="flex items-center gap-1.5 px-4 py-2 text-sm font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-md hover:shadow-lg transition-all">
                    {editingDiaryId ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />} {editingDiaryId ? 'Salva Modifiche' : 'Aggiungi Nota'}
                  </button>
                  {editingDiaryId && (
                    <button onClick={() => { setEditingDiaryId(null); setDiaryForm({ titolo: '', contenuto: '', tipo: 'nota_clinica', data: new Date().toISOString().slice(0,10) }) }} className="px-4 py-2 text-sm font-bold text-slate-500 bg-slate-100 hover:bg-slate-200 rounded-xl transition-all">
                      Annulla
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* Diary entries */}
            {diary.length === 0 ? (
              <div className="text-center py-12 text-slate-300">
                <FileText className="w-12 h-12 mx-auto mb-3 opacity-30" />
                <p className="text-sm font-bold">Nessuna nota nel diario</p>
                {isStaffPlus && <p className="text-xs mt-1">Aggiungi la prima nota clinica</p>}
              </div>
            ) : (
              <div className="space-y-3">
                {diary.map(entry => {
                  const tipoColors: Record<string, string> = {
                    nota_clinica: 'bg-blue-50 border-blue-200 text-blue-700',
                    cambio_peg: 'bg-amber-50 border-amber-200 text-amber-700',
                    evento: 'bg-purple-50 border-purple-200 text-purple-700',
                    altro: 'bg-slate-50 border-slate-200 text-slate-700',
                  }
                  const tipoLabels: Record<string, string> = { nota_clinica: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¹ Nota', cambio_peg: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â§ PEG', evento: 'ÃƒÂ¢Ã…Â¡Ã‚Â¡ Evento', altro: 'ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã…â€™ Altro' }
                  // Estrai ora dalla data di creazione o usa 00:00
                  const timeStr = entry.created_at ? new Date(entry.created_at).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '';
                  
                  return (
                    <div key={entry.id} className={`bg-white rounded-xl border p-4 transition-all ${editingDiaryId === entry.id ? 'border-indigo-500 shadow-md ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300'}`}>
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded border ${tipoColors[entry.tipo] || tipoColors.altro}`}>
                              {tipoLabels[entry.tipo] || entry.tipo}
                            </span>
                            <span className="text-xs font-bold text-slate-500">{new Date(entry.data).toLocaleDateString('it-IT')}</span>
                            {timeStr && <span className="text-xs text-slate-400">ÃƒÂ°Ã…Â¸Ã¢â‚¬Â¢Ã¢â‚¬â„¢ {timeStr}</span>}
                            {entry.created_by && <span className="text-xs text-slate-400 bg-slate-50 px-1.5 py-0.5 rounded border border-slate-100 flex items-center gap-1"><User className="w-3 h-3" /> {entry.created_by}</span>}
                          </div>
                          <div className="text-sm font-bold text-slate-800 mt-1">{entry.titolo}</div>
                          {entry.contenuto && <div className="text-sm text-slate-600 mt-1 whitespace-pre-wrap">{entry.contenuto}</div>}
                        </div>
                        <div className="flex items-center gap-1">
                          {isAdmin && (
                            <button onClick={() => { setEditingDiaryId(entry.id); setDiaryForm({ titolo: entry.titolo, contenuto: entry.contenuto || '', tipo: entry.tipo || 'nota_clinica', data: entry.data }); setDetailTab('diario'); window.scrollTo({ top: 0, behavior: 'smooth' }) }}
                              className="p-1.5 text-slate-300 hover:bg-indigo-50 hover:text-indigo-600 rounded-lg transition-all" title="Modifica Nota"><Edit3 className="w-4 h-4" /></button>
                          )}
                          {isSuperAdmin && (
                            <button onClick={() => handleDeleteDiaryEntry(entry.id, selectedPatient.id)}
                              className="p-1.5 text-slate-300 hover:bg-red-50 hover:text-red-600 rounded-lg transition-all" title="Elimina Nota"><Trash2 className="w-4 h-4" /></button>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )}

        {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: ARCHIVIO ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
        {detailTab === 'archivio' && (
          <div className="space-y-4">
            {isStaffPlus && (
              <div className="bg-white rounded-2xl border border-slate-200 p-6 flex flex-col items-center justify-center text-center">
                <div className="w-12 h-12 bg-indigo-50 rounded-full flex items-center justify-center mb-3">
                  <UploadCloud className="w-6 h-6 text-indigo-500" />
                </div>
                <h4 className="text-sm font-bold text-slate-800 mb-1">Carica un nuovo documento</h4>
                <p className="text-xs text-slate-500 mb-4 max-w-sm">Referti, consensi, foto stomia o medicazione. I file caricati saranno associati al fascicolo clinico.</p>
                <label className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold hover:bg-indigo-700 hover:shadow-md transition-all cursor-pointer">
                  {uploadingDoc ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
                  {uploadingDoc ? 'Caricamento...' : 'Seleziona File'}
                  <input type="file" className="hidden" disabled={uploadingDoc} onChange={e => { const f = e.target.files?.[0]; if (f) handleUploadPatientDocument(f); e.target.value = '' }} />
                </label>
              </div>
            )}
            
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {patientDocuments.length === 0 ? (
                <div className="col-span-full py-10 text-center text-slate-300">
                  <FolderOpen className="w-12 h-12 mx-auto mb-2 opacity-30" />
                  <p className="text-sm font-bold">Nessun documento in archivio</p>
                </div>
              ) : (
                patientDocuments.map(doc => (
                  <div key={doc.id} className="bg-white rounded-xl border border-slate-200 p-4 flex items-start gap-4 hover:border-indigo-300 transition-all group shadow-sm hover:shadow">
                    <div className={`p-3 rounded-xl flex-shrink-0 ${doc.categoria === 'pdf' ? 'bg-rose-50 text-rose-500' : 'bg-blue-50 text-blue-500'}`}>
                      <FileText className="w-6 h-6" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-bold text-slate-800 truncate mb-1 border-b border-transparent group-hover:border-slate-200 pb-0.5" title={doc.nome}>{doc.nome}</div>
                      <div className="text-[10px] text-slate-400 font-medium mb-3 uppercase tracking-wider">
                        {new Date(doc.created_at || '').toLocaleDateString('it-IT')} Ãƒâ€šÃ‚Â· {doc.categoria}
                      </div>
                      <div className="flex items-center gap-2 mt-auto">
                        {doc.url && (
                          <a href={doc.url} target="_blank" rel="noreferrer" className="flex-1 flex justify-center items-center gap-1.5 px-3 py-1.5 bg-slate-50 hover:bg-indigo-50 text-slate-600 hover:text-indigo-600 rounded-lg text-xs font-bold transition-all border border-slate-200 hover:border-indigo-200 shadow-sm">
                            <Download className="w-3.5 h-3.5" /> Apri
                          </a>
                        )}
                        {isAdmin && (
                          <button onClick={() => handleDeletePatientDocument(doc)} className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all border border-transparent hover:border-red-100" title="Elimina file">
                            <Trash2 className="w-4 h-4" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ ÃƒÂ¢Ã¢â‚¬Â¢Ã‚  TAB: APPUNTAMENTI ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ ÃƒÂ¢Ã¢â‚¬Â¢Ã‚  */}
        {detailTab === 'appuntamenti' && (
          <div className="space-y-4">
            <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
              <div className="p-5 border-b border-slate-200 flex items-center justify-between flex-wrap gap-2">
                <h3 className="text-sm font-black text-slate-800 uppercase tracking-wider">📅 Agenda Appuntamenti<button onClick={() => setShowTrash(!showTrash)} className={`ml-2 px-2 py-0.5 text-[10px] font-bold rounded ${showTrash ? 'bg-slate-800 text-white' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}>{showTrash ? 'Nascondi Cestino' : 'Mostra Cestino'}</button></h3>
                {isStaffPlus && (
                  <div className="flex items-center gap-2">
                    <button onClick={() => { setShowRimborsi(true); setRimborsiApptIds(new Set(appts.filter(a => a.completato && a.access_id).map(a => a.id))) }}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-emerald-600 bg-emerald-50 border border-emerald-200 rounded-xl hover:bg-emerald-100 transition-all">
                      <Euro className="w-3.5 h-3.5" /> Rimborsi
                    </button>
                    <button onClick={() => handleGenerateExtension(selectedPatient)}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-indigo-600 bg-indigo-50 border border-indigo-200 rounded-xl hover:bg-indigo-100 transition-all">
                      <Plus className="w-3.5 h-3.5" /> Genera prossimi 6 mesi
                    </button>
                    <button onClick={() => setShowExtraAccess(true)}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-amber-600 bg-amber-50 border border-amber-200 rounded-xl hover:bg-amber-100 transition-all">
                      <Plus className="w-3.5 h-3.5" /> Accesso Extra
                    </button>
                  </div>
                )}
              </div>

              <div className="divide-y divide-slate-100">
                {appts.map(appt => {
                  const style = TIPO_STYLES[appt.tipo] || TIPO_STYLES.altro
                  const Icon = style.icon
                  const days = appt.data_prevista ? daysUntil(appt.data_prevista) : null
                  const isOverdue = days !== null && days < 0 && !appt.completato
                  const isSoon = days !== null && days <= 3 && days >= 0 && !appt.completato

                  return (
                    <div key={appt.id} className={`p-4 flex items-center gap-4 transition-colors ${appt.completato ? 'bg-slate-50/50' : isOverdue ? 'bg-red-50/30' : ''}`}>
                      <div className={`w-3 h-3 rounded-full flex-shrink-0 ${appt.completato ? 'bg-green-400' : isOverdue ? 'bg-red-400 animate-pulse' : 'bg-slate-200'}`} />
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold border ${style.bg} ${style.text}`}>
                            <Icon className="w-2.5 h-2.5" /> {appt.luogo === 'ospedale' ? 'Osp.' : 'Dom.'}
                          </span>
                          <span className={`text-xs font-bold truncate ${appt.completato ? 'text-slate-400 line-through' : 'text-slate-800'}`}>{appt.descrizione}</span>
                        </div>
                        <div className="flex items-center gap-3 mt-1 text-xs text-slate-400 flex-wrap">
                          {isStaffPlus && !appt.completato ? (
                            <>
                              <input type="date" defaultValue={appt.data_prevista || ''} onBlur={e => { if (e.target.value !== (appt.data_prevista || '')) supabase.from('appointments').update({ data_prevista: e.target.value || null }).eq('id', appt.id).then(() => fetchAll(false)) }}
                                className="px-1.5 py-0.5 text-xs border border-slate-200 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-400 bg-white" />
                              <div className="flex items-center gap-1">
                                <span>ÃƒÂ°Ã…Â¸Ã¢â‚¬Â¢Ã‚Â</span>
                                <input type="time" value={appt.ora_prevista || ''} onChange={e => handleUpdateTime(appt.id, e.target.value)}
                                  className="px-1.5 py-0.5 text-xs border border-slate-200 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-400 bg-white w-[80px]" />
                              </div>
                            </>
                          ) : (
                            <>
                              {appt.data_prevista && <span>ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¦ {new Date(appt.data_prevista).toLocaleDateString('it-IT')}</span>}
                              {appt.ora_prevista && <span>ÃƒÂ°Ã…Â¸Ã¢â‚¬Â¢Ã‚Â {appt.ora_prevista}</span>}
                            </>
                          )}
                          {appt.data_effettiva && <span>ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ {new Date(appt.data_effettiva).toLocaleDateString('it-IT')}</span>}
                          {appt.nurse_id && appt.nurse_id !== selectedPatient.nurse_id && (
                            <span className="text-indigo-500 font-bold">ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ‚Â¤ {getNurseName(appt.nurse_id)}</span>
                          )}
                        </div>
                      </div>
                      {isStaffPlus && (
                        <div className="flex items-center gap-1">
                          {!appt.completato && (
                            <select value={appt.nurse_id || ''} onChange={e => handleReassignApptNurse(appt.id, e.target.value)}
                              className="px-1.5 py-1.5 text-[10px] border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-indigo-400 max-w-[100px]">
                              {nurses.map(n => <option key={n.id} value={n.id}>{n.cognome}</option>)}
                            </select>
                          )}
                          <button onClick={() => handleToggleComplete(appt)}
                            className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-bold transition-all border
                              ${appt.completato ? 'text-slate-500 bg-slate-50 border-slate-200 hover:bg-red-50 hover:text-red-600' : 'text-green-700 bg-green-50 border-green-200 hover:bg-green-100'}`}>
                            {appt.completato ? <X className="w-3.5 h-3.5" /> : <Check className="w-3.5 h-3.5" />}
                            {appt.completato ? 'Riapri' : 'Fatto'}
                          </button>
                          {appt.completato && appt.access_id && (
                            <span className="px-2 py-1.5 text-[10px] border border-emerald-200 rounded-lg bg-emerald-50 text-emerald-700 font-bold" title="Ore registrate">
                              ÃƒÂ¢Ã‚ÂÃ‚Â±ÃƒÂ¯Ã‚Â¸Ã‚Â
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
              {appts.length === 0 && (
                <div className="text-center py-12 text-slate-300">
                  <Calendar className="w-12 h-12 mx-auto mb-3 opacity-30" />
                  <p className="text-sm">Nessun appuntamento programmato</p>
                </div>
              )}
            </div>

            {/* Rimborsi Modal */}
            {showRimborsi && (
              <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowRimborsi(false)}>
                <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg" onClick={e => e.stopPropagation()}>
                  <div className="p-5 border-b bg-gradient-to-r from-emerald-500 to-teal-600 rounded-t-2xl">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-black text-white">ÃƒÂ°Ã…Â¸Ã¢â‚¬â„¢Ã‚Â° Rimborsi Km / Extra</h3>
                      <button onClick={() => setShowRimborsi(false)} className="p-2 hover:bg-white/20 rounded-xl"><X className="w-5 h-5 text-white" /></button>
                    </div>
                  </div>
                  <div className="p-5 space-y-4">
                    <div>
                      <div className="flex items-center justify-between mb-2">
                        <label className="text-xs font-bold text-slate-500 uppercase">Accessi completati</label>
                        <button onClick={() => {
                            const allIds = new Set(appts.filter(a => a.completato && a.access_id).map(a => a.id))
                            setRimborsiApptIds(rimborsiApptIds.size === allIds.size ? new Set() : allIds)
                          }} className="text-[10px] font-bold text-emerald-600 hover:underline">
                          {rimborsiApptIds.size === appts.filter(a => a.completato && a.access_id).length ? 'Deseleziona' : 'Seleziona tutti'}
                        </button>
                      </div>
                      <div className="max-h-[150px] overflow-y-auto space-y-1 border rounded-xl p-2">
                        {appts.filter(a => a.completato && a.access_id).map(a => (
                          <label key={a.id} className={`flex items-center gap-2 p-1.5 rounded-md cursor-pointer ${rimborsiApptIds.has(a.id) ? 'bg-emerald-50' : 'hover:bg-slate-50'}`}>
                            <input type="checkbox" checked={rimborsiApptIds.has(a.id)}
                              onChange={() => { const n = new Set(rimborsiApptIds); if (n.has(a.id)) n.delete(a.id); else n.add(a.id); setRimborsiApptIds(n) }}
                              className="rounded border-emerald-300 text-emerald-600" />
                            <span className="text-xs text-slate-700 flex-1 truncate">{a.descrizione}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-3">
                      <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Km</label>
                        <input type="number" id="rimborso_km_val" defaultValue="0" step="0.1" min="0" className="w-full px-3 py-2 border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500" />
                      </div>
                      <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬/Km</label>
                        <input type="number" id="rimborso_km_rate" defaultValue="0" step="0.01" min="0" className="w-full px-3 py-2 border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500" />
                      </div>
                      <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Extra ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬</label>
                        <input type="number" id="rimborso_extra_val" defaultValue="0" step="0.5" min="0" className="w-full px-3 py-2 border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500" />
                      </div>
                    </div>
                    <button onClick={() => {
                        const km = parseFloat((document.getElementById('rimborso_km_val') as HTMLInputElement)?.value || '0')
                        const rate = parseFloat((document.getElementById('rimborso_km_rate') as HTMLInputElement)?.value || '0')
                        const extra = parseFloat((document.getElementById('rimborso_extra_val') as HTMLInputElement)?.value || '0')
                        handleBulkRimborsi(rimborsiApptIds, km, rate, extra)
                      }} disabled={rimborsiApptIds.size === 0}
                      className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-emerald-500 to-teal-600 rounded-xl shadow-md disabled:opacity-50">
                      <Check className="w-4 h-4" /> Applica a {rimborsiApptIds.size} accesso{rimborsiApptIds.size !== 1 ? 'i' : ''}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: SOSTITUTO ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
        {detailTab === 'sostituto' && (
          <div className="space-y-4">
            {isStaffPlus && (
              <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
                <button onClick={() => {
                    if (geoResults.length > 0) { setGeoResults([]); return }
                    if (selectedPatient.indirizzo && selectedPatient.indirizzo.trim()) { handleFindNearestForPatient(selectedPatient.indirizzo.trim()) }
                    else { setGeoError('ÃƒÂ¢Ã…Â¡Ã‚Â ÃƒÂ¯Ã‚Â¸Ã‚Â Nessun indirizzo registrato per questo paziente. Vai su "Anagrafica" e inserisci l\'indirizzo completo (es: Via Roma 15, Milano).') }
                  }}
                  className="w-full p-4 flex items-center gap-3 hover:bg-slate-50/50 transition-colors">
                  <div className="p-2 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl">
                    <Crosshair className="w-5 h-5 text-white" />
                  </div>
                  <div className="text-left flex-1">
                    <div className="text-sm font-black text-slate-800">ÃƒÂ°Ã…Â¸Ã…Â½Ã‚Â¯ Trova Sostituto PiÃƒÆ’Ã‚Â¹ Vicino</div>
                    <div className="text-xs text-slate-400">Cerca operatori vicini a {selectedPatient.indirizzo || 'indirizzo paziente'}</div>
                  </div>
                  {geoSearching ? <Loader2 className="w-5 h-5 animate-spin text-indigo-500" /> :
                    <ChevronRight className={`w-5 h-5 text-slate-300 transition-transform ${geoResults.length > 0 ? 'rotate-90' : ''}`} />}
                </button>
                {geoError && <div className="px-4 pb-3 text-xs text-red-500">{geoError}</div>}

                {geoResults.length > 0 && (
                  <div className="border-t border-slate-200 p-4 space-y-2">
                    {geoResults.map((r, idx) => {
                      const isCurrentNurse = r.nurse.id === selectedPatient.nurse_id
                      return (
                        <div key={r.nurse.id} className={`p-3 rounded-xl border transition-all ${isCurrentNurse ? 'bg-indigo-50 border-indigo-300' : r.inRange ? 'bg-white border-green-200' : 'bg-slate-50 border-slate-200'}`}>
                          <div className="flex items-center gap-3">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-black flex-shrink-0 ${
                              idx === 0 ? 'bg-gradient-to-br from-amber-400 to-orange-500 text-white' :
                              idx === 1 ? 'bg-gradient-to-br from-slate-300 to-slate-400 text-white' :
                              idx === 2 ? 'bg-gradient-to-br from-amber-600 to-amber-700 text-white' : 'bg-slate-100 text-slate-500'
                            }`}>{idx + 1}</div>
                            <div className="flex-1 min-w-0">
                              <div className="text-sm font-bold text-slate-800">
                                {r.nurse.cognome} {r.nurse.nome}
                                {isCurrentNurse && <span className="text-xs text-indigo-500 ml-2">(attuale)</span>}
                              </div>
                              <div className="text-[10px] text-slate-400">{r.nurse.qualifica} Ãƒâ€šÃ‚Â· {r.nurse.provincia}</div>
                            </div>
                            <span className={`text-xs font-bold px-2 py-0.5 rounded ${r.inRange ? 'text-green-700 bg-green-50 border border-green-200' : 'text-slate-500 bg-slate-100'}`}>{r.distanceKm} km</span>
                          </div>
                          {!isCurrentNurse && (
                            <div className="mt-2 pt-2 border-t border-slate-100">
                              <div className="flex items-center gap-2">
                                {r.nurse.telefono && (
                                  <a href={`tel:${r.nurse.telefono}`} className="flex items-center gap-1 px-2 py-1 text-[10px] font-bold text-blue-600 bg-blue-50 rounded-lg border border-blue-200 hover:bg-blue-100">
                                    <Phone className="w-3 h-3" /> {r.nurse.telefono}
                                  </a>
                                )}
                                <div className="flex-1" />
                                <button onClick={() => { setReassignNurseId(reassignNurseId === r.nurse.id ? null : r.nurse.id); setReassignApptIds(new Set()) }}
                                  className={`flex items-center gap-1 px-2 py-1 text-[10px] font-bold rounded-lg border transition-all ${
                                    reassignNurseId === r.nurse.id ? 'text-white bg-amber-500 border-amber-600' : 'text-amber-700 bg-amber-50 border-amber-200 hover:bg-amber-100'}`}>
                                  <Calendar className="w-3 h-3" /> Seleziona accessi
                                </button>
                                <button onClick={() => handleReassignPatientNurse(selectedPatient, r.nurse.id)}
                                  className="flex items-center gap-1 px-2 py-1 text-[10px] font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg hover:shadow-md transition-all">
                                  <Users className="w-3 h-3" /> Permanente
                                </button>
                              </div>
                              {reassignNurseId === r.nurse.id && (() => {
                                const futureAppts = appts.filter(a => !a.completato)
                                return (
                                  <div className="mt-2 bg-amber-50/50 rounded-lg p-2.5 border border-amber-200 space-y-1.5">
                                    <div className="flex items-center justify-between">
                                      <span className="text-[10px] font-bold text-amber-700">Seleziona accessi:</span>
                                      <button onClick={() => setReassignApptIds(reassignApptIds.size === futureAppts.length ? new Set() : new Set(futureAppts.map(a => a.id)))}
                                        className="text-[9px] font-bold text-amber-600 hover:underline">
                                        {reassignApptIds.size === futureAppts.length ? 'Deseleziona' : 'Seleziona tutti'}
                                      </button>
                                    </div>
                                    <div className="max-h-[120px] overflow-y-auto space-y-1">
                                      {futureAppts.map(a => (
                                        <label key={a.id} className={`flex items-center gap-2 p-1.5 rounded-md cursor-pointer ${reassignApptIds.has(a.id) ? 'bg-amber-100' : 'hover:bg-amber-50'}`}>
                                          <input type="checkbox" checked={reassignApptIds.has(a.id)}
                                            onChange={() => { const n = new Set(reassignApptIds); if (n.has(a.id)) n.delete(a.id); else n.add(a.id); setReassignApptIds(n) }}
                                            className="rounded border-amber-300 text-amber-600" />
                                          <span className="text-[10px] text-slate-700 flex-1 truncate">{a.descrizione}</span>
                                          <span className="text-[9px] text-slate-400">{a.data_prevista ? new Date(a.data_prevista).toLocaleDateString('it-IT') : ''}</span>
                                        </label>
                                      ))}
                                    </div>
                                    {reassignApptIds.size > 0 && (
                                      <button onClick={() => handleBatchReassign(r.nurse.id, reassignApptIds)}
                                        className="w-full flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-lg hover:shadow-md">
                                        <Check className="w-3.5 h-3.5" /> Riassegna {reassignApptIds.size}
                                      </button>
                                    )}
                                  </div>
                                )
                              })()}
                            </div>
                          )}
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    ) : (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-2xl font-black text-slate-800">ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ‚Â¥ Pazienti in Carico</h2>
          <p className="text-sm text-slate-400 mt-0.5">{filteredPatients.length} pazienti Ãƒâ€šÃ‚Â· {scadenze.length} scadenze</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setShowScadenze(!showScadenze)}
            className={`relative flex items-center gap-1.5 px-3 py-2 text-sm font-bold rounded-xl transition-all border
              ${showScadenze ? 'text-white bg-gradient-to-r from-red-500 to-rose-600 border-red-400' : 'text-amber-700 bg-amber-50 border-amber-200 hover:bg-amber-100'}`}>
            <Bell className="w-4 h-4" /> Scadenze
            {scadenze.length > 0 && <span className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-red-500 text-white text-[10px] font-black rounded-full flex items-center justify-center">{scadenze.length}</span>}
          </button>
          {isStaffPlus && (
            <button
              onClick={() => setShowForm(true)}
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-md hover:shadow-lg transition-all">
              <Plus className="w-4 h-4" /> Nuovo Paziente
            </button>
          )}
        </div>
      </div>

      {/* Messages */}
      {error && <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700"><AlertCircle className="w-4 h-4" />{error}</div>}
      {success && <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-xl text-sm text-green-700"><Check className="w-4 h-4" />{success}</div>}

      {/* Scadenze Panel */}
      {showScadenze && scadenze.length > 0 && (
        <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-2xl border border-red-200 p-5 space-y-3">
          <h3 className="text-sm font-black text-red-800 uppercase tracking-wider flex items-center gap-2">
            <AlertTriangle className="w-4 h-4" /> Appuntamenti Scaduti o in Scadenza (7 giorni)
          </h3>
          <div className="space-y-2">
            {scadenze.slice(0, 10).map(appt => {
              const patient = patients.find(p => p.id === appt.patient_id)
              const days = daysUntil(appt.data_prevista!)
              const isOverdue = days < 0
              return (
                <div key={appt.id}
                  onClick={() => { if (patient) { setSelectedPatient(patient); setShowScadenze(false) } }}
                  className="flex items-center gap-3 p-3 bg-white rounded-xl border border-red-100 hover:border-red-300 cursor-pointer transition-all">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-black ${isOverdue ? 'bg-red-100 text-red-600' : 'bg-amber-100 text-amber-600'}`}>
                    {isOverdue ? '!' : days}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-bold text-slate-800">{patient ? `${patient.cognome} ${patient.nome}` : '?'}</div>
                    <div className="text-xs text-slate-500 truncate">{appt.descrizione}</div>
                  </div>
                  <div className={`text-xs font-bold px-2 py-0.5 rounded-md ${isOverdue ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                    {isOverdue ? `${Math.abs(days)}g fa` : days === 0 ? 'OGGI' : `tra ${days}g`}
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-300" />
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB SWITCHER ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
      <div className="flex items-center gap-1 bg-white rounded-xl border border-slate-200 p-1">
        <button onClick={() => setListTab('pazienti')}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-bold rounded-lg transition-all ${listTab === 'pazienti' ? 'bg-indigo-500 text-white shadow-sm' : 'text-slate-500 hover:bg-slate-50'}`}>
          <Users className="w-4 h-4" /> Pazienti ({filteredPatients.length})
        </button>
        <button onClick={() => setListTab('accessi')}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-bold rounded-lg transition-all ${listTab === 'accessi' ? 'bg-indigo-500 text-white shadow-sm' : 'text-slate-500 hover:bg-slate-50'}`}>
          <Calendar className="w-4 h-4" /> Prossimi Accessi ({appointments.filter(a => !a.completato && a.data_prevista).length})
        </button>
      </div>

      {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: PROSSIMI ACCESSI ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
      {listTab === 'accessi' && (() => {
        const upcoming = appointments
          .filter(a => !a.completato && a.data_prevista)
          .sort((a, b) => new Date(a.data_prevista!).getTime() - new Date(b.data_prevista!).getTime())
        if (upcoming.length === 0) return (
          <div className="text-center py-16 text-slate-300">
            <Calendar className="w-16 h-16 mx-auto mb-4 opacity-30" />
            <p className="text-lg font-bold">Nessun accesso programmato</p>
          </div>
        )
        return (
          <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
            <div className="p-4 border-b border-slate-100 bg-gradient-to-r from-indigo-50 to-purple-50">
              <h3 className="text-sm font-black text-indigo-800 uppercase tracking-wider flex items-center gap-2">
                <Calendar className="w-4 h-4" /> Tutti i Prossimi Appuntamenti
              </h3>
              <p className="text-xs text-indigo-500 mt-0.5">{upcoming.length} appuntamenti in programma</p>
            </div>
            <div className="divide-y divide-slate-50">
              {upcoming.map(appt => {
                const patient = patients.find(p => p.id === appt.patient_id)
                const days = daysUntil(appt.data_prevista!)
                const isOverdue = days < 0
                const isSoon = days >= 0 && days <= 7
                const style = TIPO_STYLES[appt.tipo] || TIPO_STYLES.altro
                const Icon = style.icon
                return (
                  <div key={appt.id} className="flex items-center gap-3 p-3 hover:bg-slate-50/50 transition-colors">
                    <div className={`w-12 h-12 rounded-xl flex flex-col items-center justify-center text-center border-2 flex-shrink-0 ${
                      isOverdue ? 'bg-red-50 border-red-300 text-red-700' :
                      isSoon ? 'bg-amber-50 border-amber-300 text-amber-700' :
                      'bg-slate-50 border-slate-200 text-slate-600'}`}>
                      <div className="text-[10px] font-bold uppercase leading-none">
                        {new Date(appt.data_prevista!).toLocaleDateString('it-IT', { month: 'short' })}
                      </div>
                      <div className="text-lg font-black leading-none">
                        {new Date(appt.data_prevista!).getDate()}
                      </div>
                    </div>
                    <div className="flex-1 min-w-0" onClick={() => { if (patient) setSelectedPatient(patient) }} style={{ cursor: 'pointer' }}>
                      <div className="flex items-center gap-2">
                        <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold border ${style.bg} ${style.text}`}>
                          <Icon className="w-2.5 h-2.5" /> {appt.luogo === 'ospedale' ? 'Osp.' : 'Dom.'}
                        </span>
                        <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                          isOverdue ? 'bg-red-100 text-red-700' : isSoon ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-500'
                        }`}>
                          {isOverdue ? `${Math.abs(days)}g fa` : days === 0 ? 'OGGI' : `${days}g`}
                        </span>
                        {appt.ora_prevista && <span className="text-[10px] text-slate-400">ÃƒÂ°Ã…Â¸Ã¢â‚¬Â¢Ã‚Â {appt.ora_prevista}</span>}
                      </div>
                      <div className="text-sm font-bold text-slate-800 truncate mt-0.5">{appt.descrizione}</div>
                      <div className="text-[10px] text-slate-400">
                        ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ‚Â¤ {patient ? `${patient.cognome} ${patient.nome}` : '?'}
                        {' Ãƒâ€šÃ‚Â· '}
                        ÃƒÂ°Ã…Â¸Ã‚Â©Ã‚Âº {getNurseName(appt.nurse_id)}
                      </div>
                    </div>
                    {isStaffPlus && (
                      <button onClick={() => handleToggleComplete(appt)}
                        className="flex items-center gap-1 px-3 py-2 rounded-xl text-xs font-bold text-green-700 bg-green-50 border border-green-200 hover:bg-green-100 transition-all flex-shrink-0">
                        <Check className="w-3.5 h-3.5" /> Fatto
                      </button>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        )
      })()}

      {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â TAB: PAZIENTI ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}
      {listTab === 'pazienti' && <>
      {/* Filters */}
      <div className="flex items-center gap-2 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Cerca paziente..." className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
        </div>
        <select value={filterNurse} onChange={e => setFilterNurse(e.target.value)}
          className="px-3 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
          <option value="">Tutti i professionisti</option>
          {nurses.map(n => <option key={n.id} value={n.id}>{n.cognome} {n.nome}</option>)}
        </select>
        <select value={filterPercorso} onChange={e => setFilterPercorso(e.target.value)}
          className="px-3 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
          <option value="">Tutti i percorsi</option>
          <option value="naive">NAÃƒÆ’Ã‚ÂVE</option>
          <option value="switch">SWITCH</option>
        </select>
        <button onClick={() => setShowOnlyActive(!showOnlyActive)}
          className={`px-3 py-2.5 text-sm font-bold rounded-xl border transition-all ${showOnlyActive ? 'bg-green-50 text-green-700 border-green-200' : 'bg-slate-50 text-slate-500 border-slate-200'}`}>
          {showOnlyActive ? 'ÃƒÂ¢Ã¢â‚¬â€Ã‚Â Attivi' : 'ÃƒÂ¢Ã¢â‚¬â€Ã¢â‚¬Â¹ Tutti'}
        </button>
      </div>

      {/* Patient Cards */}
      {filteredPatients.length === 0 ? (
        <div className="text-center py-16 text-slate-300">
          <Users className="w-16 h-16 mx-auto mb-4 opacity-30" />
          <p className="text-lg font-bold">Nessun paziente trovato</p>
          <p className="text-sm mt-1">Crea il primo paziente cliccando "Nuovo Paziente"</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {filteredPatients.map(patient => {
            const progress = getPatientProgress(patient.id)
            const nextAppt = getNextAppointment(patient.id)
            const appts = getPatientAppointments(patient.id)
            const overdueCount = appts.filter(a => !a.completato && a.data_prevista && daysUntil(a.data_prevista) < 0).length

            return (
              <div key={patient.id} onClick={() => setSelectedPatient(patient)}
                className="bg-white rounded-2xl border border-slate-200 p-5 hover:shadow-lg hover:border-indigo-300 cursor-pointer transition-all group">
                {/* Header */}
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-black text-sm shadow-md">
                    {patient.cognome[0]}{patient.nome[0]}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-black text-slate-800 group-hover:text-indigo-600 transition-colors">{patient.cognome} {patient.nome}</div>
                    <div className="text-xs text-slate-400">{getNurseName(patient.nurse_id)}</div>
                  </div>
                  {overdueCount > 0 && (
                    <div className="w-6 h-6 bg-red-500 text-white text-[10px] font-black rounded-full flex items-center justify-center animate-pulse">
                      {overdueCount}
                    </div>
                  )}
                </div>

                {/* Tags */}
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-md ${patient.percorso_tipo === 'naive' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                    {patient.percorso_tipo === 'naive' ? 'NAÃƒÆ’Ã‚ÂVE' : 'SWITCH'}
                  </span>
                  {patient.indirizzo && <span className="text-[10px] text-slate-400 truncate max-w-[120px]">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â {patient.indirizzo}</span>}
                </div>

                {/* Progress bar */}
                <div className="mt-3">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-[10px] text-slate-400 font-bold uppercase">Avanzamento</span>
                    <span className="text-[10px] text-slate-400 font-bold">{progress}%</span>
                  </div>
                  <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                    <div className={`h-full rounded-full transition-all duration-700 ${progress === 100 ? 'bg-green-500' : 'bg-indigo-500'}`} style={{ width: `${progress}%` }} />
                  </div>
                </div>

                {/* Next appointment */}
                {nextAppt && (
                  <div className={`mt-3 flex items-center gap-2 text-xs p-2 rounded-lg border ${
                    daysUntil(nextAppt.data_prevista!) < 0 ? 'bg-red-50 border-red-200 text-red-700' :
                    daysUntil(nextAppt.data_prevista!) <= 7 ? 'bg-amber-50 border-amber-200 text-amber-700' :
                    'bg-slate-50 border-slate-200 text-slate-600'}`}>
                    <Clock className="w-3.5 h-3.5 flex-shrink-0" />
                    <span className="truncate">{nextAppt.descrizione}</span>
                    <span className="font-bold ml-auto flex-shrink-0">
                      {daysUntil(nextAppt.data_prevista!) < 0 ? `${Math.abs(daysUntil(nextAppt.data_prevista!))}g fa` :
                       daysUntil(nextAppt.data_prevista!) === 0 ? 'OGGI' : `${daysUntil(nextAppt.data_prevista!)}g`}
                    </span>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
      </>}
    </div>
    )}

    {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â SHARED MODALS (render in both views) ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}

    {/* MODAL: Nuovo/Modifica Paziente */}
    {showForm && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowForm(false)}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
          <div className="p-6 border-b border-slate-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-2xl">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-black text-white">ÃƒÂ¢Ã…Â¾Ã¢â‚¬Â¢ {form.id ? 'Modifica' : 'Nuovo'} Paziente</h3>
              <button onClick={() => setShowForm(false)} className="p-2 hover:bg-white/20 rounded-xl transition-colors"><X className="w-5 h-5 text-white" /></button>
            </div>
          </div>
          <div className="p-6 space-y-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Professionista Assegnato *</label>
              <select value={form.nurse_id || ''} onChange={e => setForm({ ...form, nurse_id: e.target.value })}
                className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
                <option value="">-- Seleziona --</option>
                {nurses.map(n => <option key={n.id} value={n.id}>{n.cognome} {n.nome}</option>)}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Nome *</label>
                <input type="text" value={form.nome || ''} onChange={e => setForm({ ...form, nome: e.target.value })} placeholder="Nome paziente"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Cognome *</label>
                <input type="text" value={form.cognome || ''} onChange={e => setForm({ ...form, cognome: e.target.value })} placeholder="Cognome paziente"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Telefono</label>
                <input type="tel" value={form.telefono || ''} onChange={e => setForm({ ...form, telefono: e.target.value })} placeholder="+39..."
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Indirizzo</label>
                <input type="text" value={form.indirizzo || ''} onChange={e => setForm({ ...form, indirizzo: e.target.value })} placeholder="Via, CAP CittÃƒÆ’Ã‚Â "
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Email</label>
                <input type="email" value={form.email || ''} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="email@esempio.it"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Centro Ospedaliero</label>
                <input type="text" value={form.centro_ospedaliero || ''} onChange={e => setForm({ ...form, centro_ospedaliero: e.target.value })} placeholder="Nome ospedale"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Caregiver Nome</label>
                <input type="text" value={form.caregiver_nome || ''} onChange={e => setForm({ ...form, caregiver_nome: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Caregiver Cognome</label>
                <input type="text" value={form.caregiver_cognome || ''} onChange={e => setForm({ ...form, caregiver_cognome: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Caregiver Tel.</label>
                <input type="tel" value={form.caregiver_telefono || ''} onChange={e => setForm({ ...form, caregiver_telefono: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Tipo Percorso *</label>
                <select value={form.percorso_tipo || 'naive'} onChange={e => setForm({ ...form, percorso_tipo: e.target.value as any })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
                  <option value="naive">NAÃƒÆ’Ã‚ÂVE</option>
                  <option value="switch">SWITCH</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Data Inizio</label>
                <input type="date" value={form.data_inizio_percorso || ''} onChange={e => setForm({ ...form, data_inizio_percorso: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Data 1Ãƒâ€šÃ‚Â° Hospital</label>
                <input type="date" value={(form as any).data_hospital || ''} onChange={e => setForm({ ...form, data_hospital: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Data 1Ãƒâ€šÃ‚Â° Domiciliare</label>
                <input type="date" value={(form as any).data_primo_domiciliare || ''} onChange={e => setForm({ ...form, data_primo_domiciliare: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="border border-slate-200 rounded-xl overflow-hidden">
              <button type="button" onClick={() => setShowFormClinic(!showFormClinic)}
                className="w-full px-4 py-3 flex items-center gap-2 hover:bg-slate-50/50 transition-colors bg-white">
                <Stethoscope className="w-4 h-4 text-teal-500" />
                <span className="text-xs font-bold text-slate-600 uppercase">Dati Clinici (opzionale)</span>
                <div className="flex-1" />
                <ChevronDown className={`w-4 h-4 text-slate-300 transition-transform ${showFormClinic ? 'rotate-180' : ''}`} />
              </button>
              {showFormClinic && (
                <div className="p-4 space-y-3 bg-slate-50/50 border-t border-slate-200">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Patologia</label>
                      <input type="text" value={form.patologia || ''} onChange={e => setForm({ ...form, patologia: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Neurologo Prescrittore</label>
                      <input type="text" value={form.neurologo_prescrittore || ''} onChange={e => setForm({ ...form, neurologo_prescrittore: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Seriale Pompa</label>
                      <input type="text" value={form.seriale_pompa || ''} onChange={e => setForm({ ...form, seriale_pompa: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Dimensioni Tubo</label>
                      <input type="text" value={form.dimensioni_tubo || ''} onChange={e => setForm({ ...form, dimensioni_tubo: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Note</label>
              <textarea value={form.note || ''} onChange={e => setForm({ ...form, note: e.target.value })}
                rows={2} placeholder="Note aggiuntive..."
                className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none" />
            </div>
          </div>
          <div className="p-6 border-t border-slate-200 flex justify-end gap-3">
            <button onClick={() => setShowForm(false)} className="px-4 py-2 text-sm font-bold text-slate-500 bg-slate-100 rounded-xl">Annulla</button>
            <button onClick={handleCreatePatient} disabled={saving}
              className="px-6 py-2 text-sm font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-md disabled:opacity-50">
              {saving ? <Loader2 className="w-4 h-4 animate-spin inline mr-1" /> : <Plus className="w-4 h-4 inline mr-1" />}
              {form.id ? 'Salva Modifiche' : 'Crea Paziente + Appuntamenti'}
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ORE MODAL */}
    {oreModal.show && oreModal.appt && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setOreModal({ show: false, appt: null, ore: '1' })}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm" onClick={e => e.stopPropagation()}>
          <div className="p-6 border-b border-slate-200">
            <h3 className="text-lg font-black text-slate-800">ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Completa Appuntamento</h3>
            <p className="text-sm text-slate-400 mt-1">{oreModal.appt.descrizione}</p>
          </div>
          <div className="p-6 space-y-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-2 uppercase">Ore impiegate per l'accesso</label>
              <div className="grid grid-cols-4 gap-2 mb-3">
                {['0.5','1','1.5','2','2.5','3','4','6'].map(v => (
                  <button key={v} onClick={() => setOreModal(prev => ({ ...prev, ore: v }))}
                    className={`py-2 rounded-xl text-sm font-bold transition-all border-2 ${oreModal.ore === v ? 'bg-indigo-500 text-white border-indigo-500' : 'bg-slate-50 text-slate-600 border-slate-200 hover:border-indigo-300'}`}>
                    {v}h
                  </button>
                ))}
              </div>
              <input id="ore-modal-input" type="text" value={oreModal.ore} onChange={e => setOreModal(prev => ({ ...prev, ore: e.target.value }))}
                placeholder="Es: 1.5"
                className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-indigo-500" />
            </div>
            <div className="bg-amber-50 rounded-xl p-3 border border-amber-200">
              <div className="text-xs font-bold text-amber-600 uppercase">Anteprima</div>
              <div className="text-sm font-black text-amber-800 mt-1">{parseFloat(oreModal.ore.replace(',','.')) || 1} ore verranno registrate in fatturazione</div>
            </div>
          </div>
          <div className="p-6 border-t border-slate-200 flex justify-end gap-3">
            <button onClick={() => setOreModal({ show: false, appt: null, ore: '1' })} className="px-4 py-2.5 text-sm font-bold text-slate-500 bg-slate-100 rounded-xl hover:bg-slate-200">Annulla</button>
            <button onClick={() => handleConfirmOreModal()}
              className="flex items-center gap-2 px-6 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl shadow-md hover:shadow-lg">
              <Check className="w-4 h-4" /> Conferma
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ABBANDONO MODAL */}
    {abbandonoModal.show && selectedPatient && (() => {
      const patientAppts = appointments.filter(a => a.patient_id === selectedPatient.id)
      const pendingCount = patientAppts.filter(a => !a.completato).length
      const completedCount = patientAppts.filter(a => a.completato).length
      const totalToDelete = abbandonoModal.includiCompletati ? patientAppts.length : pendingCount
      return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setAbbandonoModal({ show: false, motivo: '', includiCompletati: false })}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
            <div className="p-6 border-b border-slate-200 bg-gradient-to-r from-red-50 to-orange-50 rounded-t-2xl">
              <h3 className="text-lg font-black text-red-800">ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â« Abbandono Programma</h3>
              <p className="text-sm text-red-600 mt-1">Stai per segnare il programma di <strong>{selectedPatient.cognome} {selectedPatient.nome}</strong> come abbandonato.</p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-2 uppercase">Motivazione dell'abbandono *</label>
                <textarea value={abbandonoModal.motivo} onChange={e => setAbbandonoModal(prev => ({ ...prev, motivo: e.target.value }))}
                  rows={3} placeholder="Es: La paziente ha deciso di non proseguire con il percorso terapeutico..."
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-red-500 resize-none" autoFocus />
              </div>
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 space-y-2">
                <div className="text-xs font-bold text-slate-500 uppercase">Riepilogo appuntamenti</div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-600">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¦ Da eliminare (non completati)</span>
                  <span className="font-bold text-red-600">{pendingCount}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-600">ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ GiÃƒÆ’Ã‚Â  completati</span>
                  <span className="font-bold text-green-600">{completedCount}</span>
                </div>
              </div>
              {completedCount > 0 && (
                <label className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-xl cursor-pointer hover:bg-amber-100 transition-colors">
                  <input type="checkbox" checked={abbandonoModal.includiCompletati}
                    onChange={e => setAbbandonoModal(prev => ({ ...prev, includiCompletati: e.target.checked }))}
                    className="mt-0.5 rounded border-amber-300 text-red-600 focus:ring-red-500" />
                  <div>
                    <div className="text-sm font-bold text-amber-800">Includi anche i {completedCount} completati</div>
                    <div className="text-xs text-amber-600 mt-0.5">ÃƒÂ¢Ã…Â¡Ã‚Â ÃƒÂ¯Ã‚Â¸Ã‚Â EliminerÃƒÆ’Ã‚Â  anche gli accessi in fatturazione collegati</div>
                  </div>
                </label>
              )}
              <div className={`rounded-xl p-3 border ${totalToDelete > 0 ? 'bg-red-50 border-red-200' : 'bg-slate-50 border-slate-200'}`}>
                <div className="text-xs font-bold text-slate-500 uppercase">Risultato</div>
                <div className={`text-sm font-black mt-1 ${totalToDelete > 0 ? 'text-red-700' : 'text-slate-600'}`}>
                  {totalToDelete > 0
                    ? `${totalToDelete} appuntament${totalToDelete === 1 ? 'o verrÃƒÆ’Ã‚Â  eliminato' : 'i verranno eliminati'}`
                    : 'Nessun appuntamento da eliminare'}
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3">
              <button onClick={() => setAbbandonoModal({ show: false, motivo: '', includiCompletati: false })} className="px-4 py-2.5 text-sm font-bold text-slate-500 bg-slate-100 rounded-xl hover:bg-slate-200">Annulla</button>
              <button onClick={() => handleAbbandonoProgramma(selectedPatient)}
                disabled={!abbandonoModal.motivo.trim()}
                className="flex items-center gap-2 px-6 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-red-500 to-rose-600 rounded-xl shadow-md hover:shadow-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all">
                <AlertTriangle className="w-4 h-4" /> Conferma Abbandono
              </button>
            </div>
          </div>
        </div>
      )
    })()}

    {/* ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â SHARED MODALS (render in both views) ÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚ÂÃƒÂ¢Ã¢â‚¬Â¢Ã‚Â */}

    {/* MODAL: Nuovo/Modifica Paziente */}
    {showForm && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowForm(false)}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
          <div className="p-6 border-b border-slate-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-2xl">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-black text-white">{form.id ? 'ÃƒÂ¢Ã…â€œÃ‚ÂÃƒÂ¯Ã‚Â¸Ã‚Â Modifica' : 'ÃƒÂ¢Ã…Â¾Ã¢â‚¬Â¢ Nuovo'} Paziente</h3>
              <button onClick={() => setShowForm(false)} className="p-2 hover:bg-white/20 rounded-xl transition-colors"><X className="w-5 h-5 text-white" /></button>
            </div>
          </div>
          <div className="p-6 space-y-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Professionista Assegnato *</label>
              <select value={form.nurse_id || ''} onChange={e => setForm({ ...form, nurse_id: e.target.value })}
                className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
                <option value="">-- Seleziona --</option>
                {nurses.map(n => <option key={n.id} value={n.id}>{n.cognome} {n.nome}</option>)}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Nome *</label>
                <input type="text" value={form.nome || ''} onChange={e => setForm({ ...form, nome: e.target.value })} placeholder="Nome paziente"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Cognome *</label>
                <input type="text" value={form.cognome || ''} onChange={e => setForm({ ...form, cognome: e.target.value })} placeholder="Cognome paziente"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Telefono</label>
                <input type="tel" value={form.telefono || ''} onChange={e => setForm({ ...form, telefono: e.target.value })} placeholder="+39..."
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Indirizzo</label>
                <input type="text" value={form.indirizzo || ''} onChange={e => setForm({ ...form, indirizzo: e.target.value })} placeholder="Via, CAP CittÃƒÆ’Ã‚Â "
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Email</label>
                <input type="email" value={form.email || ''} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="email@esempio.it"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Centro Ospedaliero</label>
                <input type="text" value={form.centro_ospedaliero || ''} onChange={e => setForm({ ...form, centro_ospedaliero: e.target.value })} placeholder="Nome ospedale"
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Caregiver Nome</label>
                <input type="text" value={form.caregiver_nome || ''} onChange={e => setForm({ ...form, caregiver_nome: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Caregiver Cognome</label>
                <input type="text" value={form.caregiver_cognome || ''} onChange={e => setForm({ ...form, caregiver_cognome: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Caregiver Tel.</label>
                <input type="tel" value={form.caregiver_telefono || ''} onChange={e => setForm({ ...form, caregiver_telefono: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Tipo Percorso *</label>
                <select value={form.percorso_tipo || 'naive'} onChange={e => setForm({ ...form, percorso_tipo: e.target.value as any })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
                  <option value="naive">NAÃƒÆ’Ã‚ÂVE</option>
                  <option value="switch">SWITCH</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Data Inizio</label>
                <input type="date" value={form.data_inizio_percorso || ''} onChange={e => setForm({ ...form, data_inizio_percorso: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Data 1Ãƒâ€šÃ‚Â° Hospital</label>
                <input type="date" value={(form as any).data_hospital || ''} onChange={e => setForm({ ...form, data_hospital: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Data 1Ãƒâ€šÃ‚Â° Domiciliare</label>
                <input type="date" value={(form as any).data_primo_domiciliare || ''} onChange={e => setForm({ ...form, data_primo_domiciliare: e.target.value })}
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>
            <div className="border border-slate-200 rounded-xl overflow-hidden">
              <button type="button" onClick={() => setShowFormClinic(!showFormClinic)}
                className="w-full px-4 py-3 flex items-center gap-2 hover:bg-slate-50/50 transition-colors bg-white">
                <Stethoscope className="w-4 h-4 text-teal-500" />
                <span className="text-xs font-bold text-slate-600 uppercase">Dati Clinici (opzionale)</span>
                <div className="flex-1" />
                <ChevronDown className={`w-4 h-4 text-slate-300 transition-transform ${showFormClinic ? 'rotate-180' : ''}`} />
              </button>
              {showFormClinic && (
                <div className="p-4 space-y-3 bg-slate-50/50 border-t border-slate-200">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Patologia</label>
                      <input type="text" value={form.patologia || ''} onChange={e => setForm({ ...form, patologia: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Neurologo Prescrittore</label>
                      <input type="text" value={form.neurologo_prescrittore || ''} onChange={e => setForm({ ...form, neurologo_prescrittore: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Seriale Pompa</label>
                      <input type="text" value={form.seriale_pompa || ''} onChange={e => setForm({ ...form, seriale_pompa: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-0.5">Dimensioni Tubo</label>
                      <input type="text" value={form.dimensioni_tubo || ''} onChange={e => setForm({ ...form, dimensioni_tubo: e.target.value })}
                        className="w-full px-2.5 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-teal-500" />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-1 uppercase">Note</label>
              <textarea value={form.note || ''} onChange={e => setForm({ ...form, note: e.target.value })}
                rows={2} placeholder="Note aggiuntive..."
                className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none" />
            </div>
          </div>
          <div className="p-6 border-t border-slate-200 flex justify-end gap-3">
            <button onClick={() => setShowForm(false)} className="px-4 py-2 text-sm font-bold text-slate-500 bg-slate-100 rounded-xl">Annulla</button>
            <button onClick={handleCreatePatient} disabled={saving}
              className="px-6 py-2 text-sm font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-md disabled:opacity-50">
              {saving ? <Loader2 className="w-4 h-4 animate-spin inline mr-1" /> : <Plus className="w-4 h-4 inline mr-1" />}
              {form.id ? 'Salva Modifiche' : 'Crea Paziente + Appuntamenti'}
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ORE MODAL */}
    {oreModal.show && oreModal.appt && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setOreModal({ show: false, appt: null, ore: '1' })}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm" onClick={e => e.stopPropagation()}>
          <div className="p-6 border-b border-slate-200">
            <h3 className="text-lg font-black text-slate-800">ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Completa Appuntamento</h3>
            <p className="text-sm text-slate-400 mt-1">{oreModal.appt.descrizione}</p>
          </div>
          <div className="p-6 space-y-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-2 uppercase">Ore impiegate per l'accesso</label>
              <div className="grid grid-cols-4 gap-2 mb-3">
                {['0.5','1','1.5','2','2.5','3','4','6'].map(v => (
                  <button key={v} onClick={() => setOreModal(prev => ({ ...prev, ore: v }))}
                    className={`py-2 rounded-xl text-sm font-bold transition-all border-2 ${oreModal.ore === v ? 'bg-indigo-500 text-white border-indigo-500' : 'bg-slate-50 text-slate-600 border-slate-200 hover:border-indigo-300'}`}>
                    {v}h
                  </button>
                ))}
              </div>
              <input id="ore-modal-input" type="text" value={oreModal.ore} onChange={e => setOreModal(prev => ({ ...prev, ore: e.target.value }))}
                placeholder="Es: 1.5"
                className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-indigo-500" />
            </div>
            <div className="bg-amber-50 rounded-xl p-3 border border-amber-200">
              <div className="text-xs font-bold text-amber-600 uppercase">Anteprima</div>
              <div className="text-sm font-black text-amber-800 mt-1">{parseFloat(oreModal.ore.replace(',','.')) || 1} ore verranno registrate in fatturazione</div>
            </div>
          </div>
          <div className="p-6 border-t border-slate-200 flex justify-end gap-3">
            <button onClick={() => setOreModal({ show: false, appt: null, ore: '1' })} className="px-4 py-2.5 text-sm font-bold text-slate-500 bg-slate-100 rounded-xl hover:bg-slate-200">Annulla</button>
            <button onClick={() => handleConfirmOreModal()}
              className="flex items-center gap-2 px-6 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl shadow-md hover:shadow-lg">
              <Check className="w-4 h-4" /> Conferma
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ABBANDONO MODAL */}
    {abbandonoModal.show && selectedPatient && (() => {
      const patientAppts = appointments.filter(a => a.patient_id === selectedPatient.id)
      const pendingCount = patientAppts.filter(a => !a.completato).length
      const completedCount = patientAppts.filter(a => a.completato).length
      const totalToDelete = abbandonoModal.includiCompletati ? patientAppts.length : pendingCount
      return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setAbbandonoModal({ show: false, motivo: '', includiCompletati: false })}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
            <div className="p-6 border-b border-slate-200 bg-gradient-to-r from-red-50 to-orange-50 rounded-t-2xl">
              <h3 className="text-lg font-black text-red-800">ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â« Abbandono Programma</h3>
              <p className="text-sm text-red-600 mt-1">Stai per segnare il programma di <strong>{selectedPatient.cognome} {selectedPatient.nome}</strong> come abbandonato.</p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-500 mb-2 uppercase">Motivazione dell'abbandono *</label>
                <textarea value={abbandonoModal.motivo} onChange={e => setAbbandonoModal(prev => ({ ...prev, motivo: e.target.value }))}
                  rows={3} placeholder="Es: La paziente ha deciso di non proseguire con il percorso terapeutico..."
                  className="w-full px-3 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-red-500 resize-none" autoFocus />
              </div>
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 space-y-2">
                <div className="text-xs font-bold text-slate-500 uppercase">Riepilogo appuntamenti</div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-600">ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¦ Da eliminare (non completati)</span>
                  <span className="font-bold text-red-600">{pendingCount}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-600">ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ GiÃƒÆ’Ã‚Â  completati</span>
                  <span className="font-bold text-green-600">{completedCount}</span>
                </div>
              </div>
              {completedCount > 0 && (
                <label className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-xl cursor-pointer hover:bg-amber-100 transition-colors">
                  <input type="checkbox" checked={abbandonoModal.includiCompletati}
                    onChange={e => setAbbandonoModal(prev => ({ ...prev, includiCompletati: e.target.checked }))}
                    className="mt-0.5 rounded border-amber-300 text-red-600 focus:ring-red-500" />
                  <div>
                    <div className="text-sm font-bold text-amber-800">Includi anche i {completedCount} completati</div>
                    <div className="text-xs text-amber-600 mt-0.5">ÃƒÂ¢Ã…Â¡Ã‚Â ÃƒÂ¯Ã‚Â¸Ã‚Â EliminerÃƒÆ’Ã‚Â  anche gli accessi in fatturazione collegati</div>
                  </div>
                </label>
              )}
              <div className={`rounded-xl p-3 border ${totalToDelete > 0 ? 'bg-red-50 border-red-200' : 'bg-slate-50 border-slate-200'}`}>
                <div className="text-xs font-bold text-slate-500 uppercase">Risultato</div>
                <div className={`text-sm font-black mt-1 ${totalToDelete > 0 ? 'text-red-700' : 'text-slate-600'}`}>
                  {totalToDelete > 0
                    ? `${totalToDelete} appuntament${totalToDelete === 1 ? 'o verrÃƒÆ’Ã‚Â  eliminato' : 'i verranno eliminati'}`
                    : 'Nessun appuntamento da eliminare'}
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3">
              <button onClick={() => setAbbandonoModal({ show: false, motivo: '', includiCompletati: false })} className="px-4 py-2.5 text-sm font-bold text-slate-500 bg-slate-100 rounded-xl hover:bg-slate-200">Annulla</button>
              <button onClick={() => handleAbbandonoProgramma(selectedPatient)}
                disabled={!abbandonoModal.motivo.trim()}
                className="flex items-center gap-2 px-6 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-red-500 to-rose-600 rounded-xl shadow-md hover:shadow-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all">
                <AlertTriangle className="w-4 h-4" /> Conferma Abbandono
              </button>
            </div>
          </div>
        </div>
      )
    })()}
      {/* EXTRA ACCESS MODAL */}
    {showExtraAccess && selectedPatient && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowExtraAccess(false)}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
          <div className="p-5 border-b bg-gradient-to-r from-amber-500 to-orange-500 rounded-t-2xl">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-black text-white">Accesso Extra</h3>
              <button onClick={() => setShowExtraAccess(false)} className="p-2 hover:bg-white/20 rounded-xl"><X className="w-5 h-5 text-white" /></button>
            </div>
            <p className="text-xs text-amber-100 mt-1">{selectedPatient.cognome} {selectedPatient.nome}</p>
          </div>
          <div className="p-5 space-y-4">
            <div>
              <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Data Accesso</label>
              <input type="date" value={extraAccessForm.data} onChange={e => setExtraAccessForm({...extraAccessForm, data: e.target.value})}
                className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-500" />
            </div>
            <div>
              <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Tipo Prestazione</label>
              <select value={extraAccessForm.tipo} onChange={e => setExtraAccessForm({...extraAccessForm, tipo: e.target.value})}
                className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-500">
                <option value="hospital_meeting">Hospital Meeting</option>
                <option value="primo_accesso">Primo Accesso</option>
                <option value="accessi_successivi">Accesso Successivo</option>
                <option value="training_farmaceutica">Training Farmaceutica</option>
              </select>
            </div>
            <div>
              <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Descrizione</label>
              <input type="text" value={extraAccessForm.descrizione} onChange={e => setExtraAccessForm({...extraAccessForm, descrizione: e.target.value})}
                placeholder="Accesso Extra" className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-500" />
            </div>
            <div>
              <label className="block text-[10px] font-bold text-slate-500 uppercase mb-1">Ore</label>
              <input type="text" value={extraAccessForm.ore} onChange={e => setExtraAccessForm({...extraAccessForm, ore: e.target.value})}
                className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-500" />
            </div>
            <button onClick={handleExtraAccess}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl shadow-md hover:shadow-lg transition-all">
              <Plus className="w-4 h-4" /> Registra Accesso Extra
            </button>
          </div>
        </div>
      </div>
    )}
  </>
  )
}
